import React from 'react';
import * as d3 from 'd3';
import {cl, globs,dateToDisplayDate,constant} from '../../components/utils/utils';
import {getPe} from '../../usa/utils/utils'
import {sd} from './sampleData'
import {acctFeature} from '../../usa/components/C18utils'


class Graph01 extends React.Component{
/* The ZCI information can come from the url, or be overridden by the dashboard or the widget*/
  constructor(props) {
    super(props);
//     cl(props)
//     cl(props.graph.sensors[0].i)
    this.svgDiv=React.createRef();
    this.width=0
    this.colorArr=[
      "#009fb9", 
      "#df568b", "#9b8610", "#348bed", "#dc5e59", "#679525", 
       "#00a086", 
      "#9478e0", 
        "#c3732e", "#009d52", "#0098df", "#c862bc"]
    this.sensors=this.props.graph.sensors.slice(0)
//     cl(this.sensors)
    this.sensors.forEach(s=>{
      s.mode="default"
      if(s.options){
        s.color=s.options.color
        s.min=s.options.min 
        s.max=s.options.max
        s.mode=s.options.mode
        // s.unit=s.options.unit
      }
    })
    this.events=this.props.graph.events.slice(0)
    // cl(this.sensors)
    this.events.forEach(s=>{
      s.mode="default"
      if(s.options){
        s.color=s.options.color
        s.min=s.options.min 
        s.max=s.options.max
        s.mode=s.options.mode
        // s.unit=s.options.unit
      }
    })
    // add axis field
    this.events.push({
        id: "default",
        min:0, 
        max:15, 
        yShow:true,
    })
    // cl(JSON.stringify(this.events))
    this.state={
//       sensors: props.graph.
        // maxheight:75
    }
//     setInterval(()=>{
//       cl(this.props.graph.ref)
//     }, 1000)
    let gr=this.props.graph
//     cl(gr)
    this.graphName=gr.divId
//     cl(this.props.graph.divId)
//     cl("init get history")
    
  }

  initVars=()=>{
    this.tempStages=["Heat 6","Heat 5","Heat 4","Heat 3","Heat 2","Heat 1","Normal",
    "Cool 1","Cool 2","Cool 3","Cool 4","Cool 5","Cool 6"]
    this.humStages=["Hum 1","Normal","Dehum 1","Dehum 2"]
    this.overrides=["None","Hum","Dh1","Dh2","DhLt","Wind","Rain","OTL",
      "OTH","Aux","Ecph","Fire","Wb","Of","Sh","Hi","Cp1","Cp2","Cp3","Sp",
      "Hail","Tim","Sch"]
  }
  
//   onSelectChange=(a,b)=>{
//     cl([a,b])
//   }
  
  getHistory=async(min,max)=>{
//       cl("getting history")
//       console.trace()
//     console.trace()
//     cl(min,max)
//     cl(Math.floor(max-min))
    let graphName=(this.props.graph.showSelect)?"guide":"main"
//     cl(`get history: ${graphName}, ${min}, ${max}`)
//     let gr=this.props.graph
//     cl(this.props.graph.showSelect)
// this was getting an extra day before and after: min-24*3600, to: max+24*3600
    let cmd={from: min, to: max, type: "arr",
      guideGraph: this.props.graph.showSelect,
      mainGraph:!this.props.graph.showSelect,
      eventTimeline: this.props.graph.divId == "event-timeline"}// get an array of sensors
    if(cmd.eventTimeline){cmd.mainGraph=false}
    let sensors=[]
//     this.props.graph.sensors
    // if (this.props.graph.divId != "event-timeline") {
        this.sensors.forEach(s=>{
//           cl(s)
          sensors.push({s:s.s, z:s.z, c:s.c, i:s.i,type:s.type,
            unit:s.unit,mult:s.mult,sensorType:s.sensorType})
        })
    // }
    cmd.sensors=sensors
    let events=[]
    this.events.forEach(s=>{
//       cl(s)
      if (s.id != "default") events.push({s:s.s, z:s.z, id:s.id})
    })
    cmd.events=events
//     cl(cmd.events)
//     cl(this.props.graph.divId)
//     cl(cmd)
//     cl("call")
    // cl(this.props.graph.divId)
    // need to refresh graph components in case of slow response from backend
    this.history=await this.props.graph.getHistory(cmd)
    this.curPe=getPe(cmd.from,cmd.to)
//     cl("got history")
//     cl(this.history)
//     cl(`done get history: ${graphName}, ${min}, ${max}`)
//     cl(this.history.sensors)
//     cl(this.sensors)
//     cl(this.history)
//     cl("done")
//     cl(this.props.graph.showSelect)
//     cl(this.history)
//     cl(this.history)
    let th=this.history
//     cl(this.history)
//     cl(`got domain ${th.from}, ${th.to}`)
    this.graph.allData=this.history||{}
    this.graph.checkNewData(min,max)

//     cl(this.props.graph.divId)
/*allData:
from and to times, and sensors object, with sensorId(site-z-c-i) keys: {t:time, d:data}*/
  }
  
  shouldComponentUpdate=()=>{
//     cl("update start")
    this.updating=true
    return true
  }

  componentWillUnmount=()=>{
    clearTimeout(this.sideBarResponsiveTimer)
    this.subscribe_SideBarClicked.remove()
  }

  SideBarClicked=()=>{
   this.sideBarResponsiveTimer = setTimeout(() => {
    if (!this.svgDiv?.current?.clientWidth) return
    if(this.width != this.svgDiv.current.clientWidth) {
      this.width = this.svgDiv.current.clientWidth
      this.graph.config.width = this.width
      // this.graph.info.width = this.svgDiv.current.clientWidth

      let div1 = this.svgDiv.current
      if(div1 && div1.id === 'main-graph') {
        let svg1 = div1.firstChild
        if(svg1) {
          svg1.setAttribute("viewBox","0 0 " + this.svgDiv.current.clientWidth + " 400")
        }
      }


      let div2 = this.svgDiv.current
      if(div2 && div2.id === 'guide-graph') {
        let svg2 = div2.firstChild
        if(svg2) {
          svg2.setAttribute("viewBox","0 0 " + this.svgDiv.current.clientWidth + " 100")
        }
        
      }

      let div3 = this.svgDiv.current
      if(div3 && div3.id === 'event-timeline') {
        let svg3 = div3.firstChild
        if(svg3) {
          svg3.setAttribute("viewBox","0 0 " + this.svgDiv.current.clientWidth + ` ${this.svgDiv.current.clientHeight}`)
        }
      }

      let gElements = document.getElementsByTagName("g");
      for(let i = 0; i < gElements.length; i++) {
          let element = gElements[i];
          element.removeAttribute('clip-path')   
      }

    }
   
      let tr=this.graph.calcTr(this.props.graph.from,this.props.graph.to)
      let [minTime,maxTime]=this.graph.calcFromTo(tr)
      this.graph.checkNewData(minTime,maxTime)
      this.svgDiv.current.focus();
   }, 500);
  }
  
  componentDidUpdate=()=>{
//     cl("update done")
    this.updating=false

  }

  windowResized=()=>{
    this.SideBarClicked()
  }
  
  componentDidMount=()=>{
    window.addEventListener('resize', this.windowResized);
//     cl(`Did Mount ${this.props.graph.divId}`)
//     cl(this.props)
    let ref=this.svgDiv.current
    this.width = ref.clientWidth
    // cl("Anas",ref.clientHeight)
    let gr=this.props.graph
//     cl(gr)
//     cl(sd)// an array ov {t: v:} objects: time, value
//     cl(gr)
    let info={
      svg:ref,//this.props.graph.ref,//.current,//
//       data: sd.sensors["0sna8jVYIh0xw6oF-0-240-23"],
      allData: sd,//.sensors["0sna8jVYIh0xw6oF-0-240-23"],
      width: ref.clientWidth,
      height: ref.clientHeight,
      options:gr.options,
      from: this.props.graph.from,// graph.from and .to are the actual limits for each graph: guide, and main
      to: this.props.graph.to,
      showSelect: gr.showSelect,// true if guide graph
      showGrid: gr.showGrid,
      showDM: gr.showDM,
      showVBar: gr.showVBar,
      showCombinedYAxis: gr.showCombinedYAxis||false,
      showMobileView: gr.showMobileView||false,
      showZoomBar: true,
      sFrom: gr.sFrom,
      sTo: gr.sTo,
    }
    this.graph = this.graph01(info)
    
    this.props.notify({id: "newSensors", func: this.graph.onNewSensors})
    this.props.notify({id: "newEvents", func: this.graph.onNewEvents})
    this.props.notify({id: "newTimePeriod", func: this.graph.onNewTimePeriod})
    if(gr.showSelect){
      this.props.notify({id: "selectZoom", func: this.graph.onSelectZoom})
    }else{
      this.props.notify({id: "selectChange", func: this.graph.onSelectChange})
    }

    this.getHistory(gr.from,gr.to)
    this.initVars()
    this.subscribe_SideBarClicked=globs.events.subscribe("sideBarClicked",this.SideBarClicked)
  }
  
graph01=(info)=>{
  
  var o={
    config:{},
    maxZoom: 300,
    maxHeight:75,
//     data: info.data,
    allData: info.allData,
    
    setYScale:(s)=>{
      // cl(["set y scale", s])
      s.y = d3.scaleLinear()
        .domain([s.min, s.max]) // input 
        .range([o.config.height, 10])
    },
    
    roundAxisMax:(val)=>{
      if(val<=1){return 1}
      let steps=[1,2,5,10,20,50,100,200,500,1000,2000,5000,10000,20000]
      for(let i=1;i<steps.length;i++){
        if(steps[i]>val){
          if(steps[i]/val>val/steps[i-1]){return steps[i]}
          return steps[i+1]||steps[steps.length-1]
        }
      }
      return steps[steps.length-1]
    },

    adjustSensorMinMax:(id,min,max,mode)=>{
//       cl(min,max)
      if(min==max){
        min-=0.1
        max+=0.1
      }
//       cl(mode)
      // if(mode=="default"){
      //   let sensorId=id.substring(2)
      //   cl(sensorId)
      //   if (["inT","inH"].includes(sensorId)){
      //     if(min>20){min=20}
      //     if(max<100){max=100}
      //   }
      // } else 
      if (mode=="minMax"){
        let avg=(min+max)/2
        let range=max-min
  //       cl(avg,range)
        min=avg-0.55*range
        max=min+1.1*range
        let minRange={inT:20,inH:10}
        let mr=minRange[id]
        if(mr){
  //         cl(mr)
          if(max-min<mr){
            min=(min+max)/2-mr/2
            max=min+mr
          }
        }
        // let sensorId=id.substring(2)
        // cl(sensorId)
        // if (["inT","inH"].includes(sensorId)){
        //   if(min>20){min=20}
        //   if(max<100){max=100}
        // }
      }
      // cl("Anas",[min,max])
      return [min,max]
    },
    
    makeFirstSensorPoint:(p1,p2,min)=>{
      let frac=(min-p1.t)/(p2.t-p1.t)
      if(frac<0){return p1}
      let d=p1.d+frac*(p2.d-p1.d)
      return {t:min,d:d}
//       return p1
      
    },

//     makeFirstEventPoint:(p1,p2,min)=>{
//       let frac=(min-p1.dispTime)/(p2.dispTime-p1.dispTime)
//       if(frac<0){return p1}
//       let d=p1.d+frac*(p2.d-p1.d)
//       return {t:min,d:d}
// //       return p1
      
//     },
    
    setSensorsData:(min,max)=>{// min and max are *times*
//       cl("set sensor",min,max)
//       cl(this.sensors)
//       cl(this.props.graph.showSelect)
      if(!o.allData.sensors || this.props.graph.divId == "event-timeline"){/*cl("no data");*/ return}
//       cl(o.allData)
//       cl(`set sensor data: ${min}, ${max}`)
      // cl(o.allData)
//       cl(`${this.props.graph.divId}`)
      // cl(this.sensors)// comes with s, z, c, i, name
      let sensorDict = {}
      this.sensors.forEach(s=>{// when new data is put in, need to rescale Y axis
        // cl(s)
        let z=(s.type=="mbPoint")?s.z+64:s.z
        let key=`${s.s}-${z}-${s.c}-${s.i}`
//         cl(s)
        s.data=[]
//         cl(s)
//         let yMin=1e6, yMax=-1e6
//         cl(key)
//         cl(o.allData.sensors)
        if(key in o.allData.sensors){
//           cl(key)
          let ads=o.allData.sensors[key]
          var inData=false
//           cl(ads.length)
//           var min0,max0
          var ld=ads[0]
          var first = false
          var last = false
          for(let i=0;i<ads.length;i++){
            let d=ads[i]
//             if(d.t<min){min0=d.d}
//             if((d.t>max)&&(!max0)){max0=d.d}
            if((ld.t<min)&&(d.t>min)){
//               cl(`before: ${i}`)
              let d2=o.makeFirstSensorPoint(ads[i-1],ads[i],min)
              s.data.push( {t:new Date(1000*d2.t), v:(o.getCurveType(s)==d3.curveStepAfter) ? ads[i-1].d:d2.d} )  // add the point *before* min        
//               cl(d2.t)
              first=true
            }
            
            if((d.t>=min)&&(d.t<max)){
//               if(yMin>d.d){yMin=d.d}
//               if(yMax<d.d){yMax=d.d}
//               if(!inData&&(i>0)){
//                 let d2=o.makeFirstSensorPoint(ads[i-1],ads[i],min)
//                 s.data.push( {t:new Date(1000*d2.t), v:d2.d} )  // add the point *before* min        
//                 inData=true
//               }
              s.data.push( {t:new Date(1000*d.t), v:d.d, gj:d.gj} ) 
            }else{
//               if(inData&&((i+1)<ads.length)){
//                 s.data.push( {t:new Date(1000*ads[i+1].t), v:ads[i+1].d} )// add the point *after* max
//                 inData=false
//               }
            }
            if((ld.t<max)&&(d.t>max)){
//               cl(`after: ${i}`)
              let d2=o.makeFirstSensorPoint(ads[i-1],ads[i],max)
              s.data.push( {t:new Date(1000*d2.t), v:(o.getCurveType(s)==d3.curveStepAfter) ? ads[i-1].d:d2.d} )  // add the point *before* min        
//               cl(d2.t)
              last=true
            }
//             cl(ld)
            ld=d
          }
          // if no first/last point, attempt to insert one based on present information
          // UPDATE 4/22 use endpoints if present
          // cl(first)
          // use endpoint data if no data found in range
//           if (!first) {
//               // ON/OFF CASE
//               let first_v = s.data[0] ? s.data[0].v : null
//               let ep_start_present = false
//               let ep_start = o.allData.ep.sensors[key]
//               // cl(ep_start)
//               if (ep_start) {
//                 for (let i = 0; i < ep_start.length; i++) {
//                   if (ep_start[i].t < min) {
//                     // cl(ep_start[i])
//                     first_v = ep_start[i].d
//                     ep_start_present = true
//                   }
//                 }
//               }
//               if (first_v) {
//                 if (s.min == 0 && s.max == 1) {
//                   s.data.unshift( {t:new Date(1000*min), v: (ep_start_present) ? first_v : first_v == 1 ? 0 : 1} )
//                 } else {
//                   s.data.unshift( {t:new Date(1000*min), v:first_v} )
//                 }
//               }
//           }
          // cl(last)
//           if (!last && s.data[s.data.length-1]) {
//               // if max time is above current time,
//               let last_v = s.data[s.data.length-1].v
//               let last_t = 1000*max
//               let ep_end_present = false
//               let ep_end = o.allData.ep.sensors[key]
//               if (ep_end) {
//                 for (let i = 0; i < ep_end.length; i++) {
//                   if (ep_end[i].t > max) {
//                     // cl(ep_end[i])
//                     last_v = ep_end[i].d
//                     last_t = ep_end[i].t * 1000
//                     ep_end_present = true
//                   }
//                 }
//               }
//               let max_ts = Math.min(last_t, (new Date()).getTime())
//               if (s.min == 0 && s.max == 1) {
//                 s.data.push( {t:new Date(max_ts), v: (ep_end_present) ? last_v : last_v == 1 ? 0 : 1})  // add the point *before* min
//               } else {
//                 s.data.push( {t:new Date(max_ts), v:last_v})  // add the point *before* min
//               }
//           }
          let dataMin=1e6, dataMax=-1e6
          s.data.forEach(d=>{
            if(dataMin>d.v){dataMin=d.v}
            if(dataMax<d.v){dataMax=d.v}
          })
          let yMin, yMax
          let hasData=dataMin<=dataMax
          if (s.mode != "minMax") {
            yMin=+s.options?.min || +s.min
            yMax=+s.options?.max || +s.max
            if(hasData){
              if(dataMax>yMax){yMax=o.roundAxisMax(dataMax)}
              if(dataMin<yMin){yMin=dataMin}
            }
          } else {
            yMin=dataMin
            yMax=dataMax
          }
//           cl([yMin,yMax])
//           o.allData.sensors[key].forEach(d=>{// this needs to be extended for the main graph to get the points *before* and *after*
//             if((d.t>=min)&&(d.t<max)){
//               if(yMin>d.d){yMin=d.d}
//               if(yMax<d.d){yMax=d.d}
//               s.data.push( {t:new Date(1000*d.t), v:d.d} )          
//             }
//           })
          // cl([yMin,yMax])
          let res=o.adjustSensorMinMax(s.id,yMin,yMax,s.mode)
          // cl(res)
//           cl(res)
//           cl(s)
//           cl(yMin,yMax)
          s.min=res[0]
          s.max=res[1]
          // check if in group
          // dli/vpd accumulation sub-readings (s.parmType set) keep their own numeric
          // min/max: they share a unit group with their equipment's on/off channel so
          // Combined Y-Axis still merges them into one axis, but they must never inherit,
          // or overwrite, the shared On/Off range (C20C22-4391)
          if (!s.parmType) {
            if (!sensorDict[`${s.unit}${s.unitGroup}`]) {
              sensorDict[`${s.unit}${s.unitGroup}`] = [s.min, s.max]
            } else {
              s.min = sensorDict[`${s.unit}${s.unitGroup}`][0]
              s.max = sensorDict[`${s.unit}${s.unitGroup}`][1]
            }
          }

          o.setYScale(s)
        }
//         cl([yMin,yMax])
//         cl(s.data)
      })
      o.minTime=min 
      o.maxTime=max
//       cl(this.sensors[0].min)
      
    },

    setEventsData:(min,max)=>{
//       cl("set events data")
//       cl([min, max])
//       cl(this.props.graph.showSelect)
//       if(!o.allData.events){cl("no data"); return}
      // cl(o.allData)
//       cl(`set sensor data: ${min}, ${max}`)
//       cl(o.allData)
      // cl(`${this.props.graph.divId}`)
//       cl(this.sensors)// comes with s, z, c, i, name
      this.events.forEach(s=>{// when new data is put in, need to rescale Y axis
        if (s.id != "default") {
        s.data=[]
        if(o.allData.events && o.allData.events[s.id]){
//           cl("setting event data for " + s.id)
          // cl(s.id)
          let ads=o.allData.events[s.id]
          var inData=false
          var ld=ads[0]
          for(let i=0;i<ads.length;i++){
            let d=ads[i]
            // if earliest data point is less than min and curr data point is more than min
            // if((ld.dispTime<min)&&(d.dispTime>min)){
            //   let d2=o.makeFirstEventPoint(ads[i-1],ads[i],min)
            //   s.data.push( {t:new Date(1000*d2.dispTime), data: d} )  // add the point *before* min        
            // }
            // if curr display time is within min and max
            switch (s.id) {
                case "ala":
                    if((d.start>=min)&&(d.start<max)){
                      s.data.push( {t:new Date(1000*d.start), data: d} ) 
                    }
                    if((d.end>=min)&&(d.end<max)){
                      s.data.push( {t:new Date(1000*d.end), data: Object.assign({ended: true}, d)}) 
                    }
                    break
                // case "alr":
                case "adl":
                    if((d.t>=min)&&(d.t<max)){
                      s.data.push( {t:new Date(1000*d.t), data: d} ) 
                    }
                    break
                // case "alr":
                default:
                    if((d.dispTime>=min)&&(d.dispTime<max)){
                      s.data.push( {t:new Date(1000*d.dispTime), data: d} ) 
                    }
                    break
            }
            // if earliest data point is less than max and curr data point is more than max
            // if((ld.dispTime<max)&&(d.dispTime>max)){
            //   let d2=o.makeFirstEventPoint(ads[i-1],ads[i],max)
            //   s.data.push( {t:new Date(1000*d2.dispTime), data: d} )  // add the point *before* min        
            // }
            ld=d
          }
          // cl(s.data)
          s.min=0
          // cl(o.config.height)
          s.max=o.config.height
          o.setYScale(s)
        }
        }
      })
      // pass data to c18graphing
      if (this.props.graph.divId == "event-timeline") this.props.graph.setEvents(this.events)
      // if (this.props.graph.divId != "main-graph") this.props.graph.setEvents(this.events)
//       cl(this.events)
      o.minTime=min 
      o.maxTime=max
    },
    
    resetZoom:()=>{
        o.zr=true
        o.zoom.transform(o.svg2,d3.zoomIdentity)
        o.zr=false
    },
    
    calcFromTo:(tr)=>{
//       cl(this.props.graph.showSelect)
      let d0=o.maxTime-o.minTime
      let d1=d0/tr.k
      let k0=(d0)/o.w
      let k1=k0/tr.k
      let ofs=k1*tr.x
      let minTime=o.minTime-ofs
      let maxTime=minTime+Math.floor(d1)
      return [minTime,maxTime]
    },
    
    calcTr:(fromVal, toVal)=>{
//       cl(o.minTime,fromVal)
      let tr={}
      let d0=o.maxTime-o.minTime
      let d1=toVal-fromVal
      let k0=d0/o.w
      let k1=d1/o.w
      let ofs=o.minTime-fromVal
//       cl(ofs)
      tr.x=ofs/k1
      tr.k=k0/k1
      tr.y=1
      return tr
    },

    checkNewData:(minTime,maxTime)=>{
      // cl("check new data")
      // cl(this.props.graph.divId)
//       console.trace()
//       cl("check new data")
      // cl(this.props.graph.isMain)
//       if(this.props.graph.isMain){
//         cl("check new data")
//         cl(this.sensors)
//       }
//       cl(`check new: ${minTime}, ${maxTime}, ${this.props.graph.showSelect}`)
/*how to convert between pixels and seconds:
tr.k is the new scale, <1 
The total time is oldTime/x
the old minTime is at tr.x
the x value is *after* the new scale
the old time scale is (max-min)/w in seconds / pixel
// */
//       cl(tr)

//       let [minTime,maxTime]=o.calcFromTo(tr)
//       cl(`domain: ${minTime}, ${maxTime}`)
//       cl(o.allData)
      if(o.svgx){o.svgx.remove()}
      if(o.svgxg){o.svgxg.remove()}
      o.addXAxis(o.svg2,minTime,maxTime)
      // add mouseover?

//       cl(minTime,maxTime)
//       let yCnt=this.sensors.length
      let yCnt=0
//       cl(this.props.graph.isMain)
      // let isMain=this.props.graph.isMain
      let isGuide=this.props.graph.divId == "guide-graph"
      let isEvent=this.props.graph.divId == "event-timeline"
      if (info.showCombinedYAxis) {
          let sensorDict = {}
          this.sensors.forEach((s) => {if(s.yShow&&!isGuide){
//             cl(s)
              if(s.axis){s.axis.remove()}
              if(s.label){s.label.remove()}
              if(s.circ){s.circ.remove()}
              if (!sensorDict[`${s.unit}${s.unitGroup}`]) {
                sensorDict[`${s.unit}${s.unitGroup}`] = true
                yCnt+=1
              }
          }})
      } else {
          this.sensors.forEach(s=>{if(s.yShow&&!isGuide){// remove y axes
            if(s.axis){s.axis.remove()}
            if(s.label){s.label.remove()}
            if(s.circ){s.circ.remove()}
    //         if(s.dmPath){s.dmPath.remove()}
            yCnt+=1
          }})
      }
      this.events.forEach(s=>{if(s.yShow&&isEvent){// remove y axes
        if(s.axis){s.axis.remove()}
        if(s.dmPath){s.dmPath.remove()}
      }})
      // cl(o.config.yAxisWidth*yCnt)
      o.x=d3.scaleLinear()// set x scale
        .domain([1000*minTime,1000*maxTime])
        .range([0+o.config.yAxisWidth*(yCnt),this.svgDiv.current?.clientWidth||o.config.width])
//       o.setData(minTime,maxTime)
      o.setSensorsData(minTime,maxTime)
      // cl(this.events)
      if (isEvent) o.setEventsData(minTime,maxTime)
      // o.setEventsData(minTime,maxTime)
      // cl(this.events)
//       cl("add y axes")
//       cl(this.sensors)

//       cl("set dispfrom")
      o.dispFrom=minTime
      o.dispTo=maxTime
//       this.sensors.forEach(s=>{if(s.path){s.path.remove()}})
//       cl(this.sensors)
//       cl("draw")
//       cl(this.props.graph.divId,isEvent)
      if (!isEvent) {
          o.addPaths()
//       cl("add shades")
          o.addShades()

          if (this.props.graph.divId == "main-graph") {
            if (o.mouseG){o.mouseG.remove()} 
            if (o.mouseBox){o.mouseBox.remove()} 
            if (info.showVBar) o.moveHandler()
        }
    //       o.dotsParent.remove()
    //       cl("add dms")
    //       cl(`Add DMs ${this.graphName}`)
      }
      // cl(isEvent)
      o.addDMs()
      o.addThreshold()
      o.setBox()
      if(!isGuide){o.addYAxes()}
      o.resetZoom()
      o.tndTime=null
//       cl(this.sensors)
//       cl(`check new Data done ${this.props.graph.divId}`)
    },
    
    showDate:(ts)=>{
      return new Date(1000*ts)
    },
    
    countDataPoints:(ad,min,max)=>{
      let count=0
      let dataPoints = Object.values(ad.sensors)[0]
      if (dataPoints) dataPoints.forEach(se=>{if((se.t>=min)&&(se.t<max)){count+=1}})
      return count
    },
    
    
    getRealData:async(minTime,maxTime)=>{// after a zoom, use getHistory to get the currently needed data
//       cl(`getRealData ${this.props.graph.divId}`)
//       let [minTime,maxTime]=o.calcFromTo(tr)
//       cl(o.allData)
//       cl(minTime,maxTime)
//       cl(this.props.graph.divId)
        await this.props.graph.cancelHistory()// any current requests

      let ad=o.allData// this is actually all the data that we have, that is used for the guide graph
      // cl(ad)
      // cl([minTime, maxTime])
//       cl([o.showDate(minTime),o.showDate(maxTime)])
//       cl([o.showDate(ad.from),o.showDate(ad.to)])
      let count=200
      if(this.props.graph.divId=="guide-graph"){
        count=o.countDataPoints(ad,minTime,maxTime)
      }
//       cl(count)
      let newPe=getPe(minTime,maxTime)
//       cl(newPe,this.curPe)
      if(
        newPe==this.curPe&&
        (ad.from<=minTime)&&
        (ad.to>=maxTime)&&
        (count>=100)
      ){//&&(count>=100)
//         cl("check new data")
        o.checkNewData(minTime,maxTime)
//         cl(minTime,maxTime)
      }else{
//         cl(`get real data get history ${this.props.graph.divId}`)
        await this.getHistory(minTime,maxTime)
        this.curPe=newPe
//         o.checkNewData(minTime,maxTime)
//         cl("need new")
      }
    },
    
    throttleNewData:(tr)=>{
      if(!o.zr){
        // cl("throttleNewData2")
//         o.getRealData(tr)
        let [minTime,maxTime]=o.calcFromTo(tr)
        if(o.tndTime){ clearTimeout(o.tndTime) }
        o.tndTime=setTimeout(()=>{o.getRealData(minTime,maxTime,this.sensors)},1000)// checkNewData
      }
    },
    
    setConfig:()=>{
//       cl("set config")
//       cl(info)
      o.config.that=this
      o.config.tzo=60*(new Date()).getTimezoneOffset()
      o.config.yAxisWidth=60
      o.config.opacity=1.0
      o.config.margin = {top: 0, right: 0, bottom: 20, left: 0}
      o.config.width = info.width-o.config.margin.left-o.config.margin.right//window.innerWidth - margin.left - margin.right // Use the window's width 
      o.config.height = o.config.height||(info.height-o.config.margin.top-o.config.margin.bottom)//window.innerHeight - margin.top - margin.bottom; // Use the window's  height
      o.config.dark=globs.device?.deviceTheme=="originalDark"
//       cl(globs.device)
      o.minTime=info.from//1624622760
      o.maxTime=info.to//o.minTime+10000
      o.dispFrom=info.from
      o.dispTo=info.to
      o.w=o.config.width
//       o.setData(o.minTime, o.maxTime)
      o.setSensorsData(o.minTime, o.maxTime)
      o.setEventsData(o.minTime, o.maxTime)
      o.x = d3.scaleLinear()
        .domain([1000*o.minTime,1000*o.maxTime])
//         .domain(d3.extent(o.config.dataset2, function(d) { return d.t; })) 
        .range([0, o.config.width]); // output
      o.y = d3.scaleLinear()
        .domain([info.yMin, info.yMax]) // input 
        .range([o.config.height, 0]); // output 
//       o.xAxis_woy = d3.axisBottom(o.x).ticks(3).tickFormat(d3.timeFormat("%y-%b-%d")).tickValues(o.config.dataset2.map(d=>d.t));
      if(this.sensors.length && this.props.graph.divId != "event-timeline"){
//           cl(this.sensors[0])
        o.xAxis_woy = d3.axisBottom(o.x).ticks(3).tickFormat(d3.timeFormat("%y-%b-%d")).tickValues(this.sensors[0].data.map(d=>d.t));
      }
      if(this.events.length > 1 && this.events[0].data && this.props.graph.divId == "event-timeline"){
          // cl(this.events[0])
          // map event data to screen
        o.xAxis_woy = d3.axisBottom(o.x).ticks(3).tickFormat(d3.timeFormat("%y-%b-%d")).tickValues(this.events[0].data.map(d=>d.t));
      }
//       cl(this.sensors[0].data)
//       cl(o)
    },

//     makeLine:()=>{
//   //     cl(this.config)
//       return d3.line()
//         .x((d, i)=> { return o.x(d.t); }) // set the x values for the line generator
//         .y((d)=> { return o.y(d.v); }) // set the y values for the line generator 
//         .curve(d3.curveMonotoneX) // apply smoothing to the line
//     },

    addDots:(svg)=>{
      o.dots=svg.selectAll(".dot")
        .data(this.sensors[0].data)
        .enter().append("circle") // Uses the enter().append() method
        .attr("class", "dot") // Assign a class for styling
        .attr("cx", (d, i)=>{ return o.x(d.t) })
        .attr("cy", (d)=>{ return o.y(d.v) })
        .attr("r", 5)
    },
    
    makeXTickVals:(min,max)=>{
      let range=max-min 
      let steps=[30,60,120,300,600,1200,1800,3600,7200,14400,28800,43200,86400,172800,345600,691200,1382400]
      var i
      for(i=0;i<steps.length;i++){
        if(range/10<steps[i]){
          break
        }
      }
      let step=steps[i]
//       cl(o.config.tzo)
      min-=o.config.tzo
      let t0=min-min%step
      t0+=o.config.tzo
      let ticks=[]
      for(let i=0;(t0+step*i)<max;i++){
        if((t0-o.config.tzo+step*i)>=min){ticks.push(new Date(1000*(t0+step*i)))}
      }
//       cl(ticks)
      return ticks
    },
    
    stageTicks:(min,max,id,setpoints)=>{
      let ticks=[]
      let showTicks={}
      if(["stT"].includes(id.substring(2))){
        for(let i=Math.floor(min);i<Math.ceil(max);i++){
          ticks.push(i)
          showTicks[i]=this.tempStages[i]
        }
      }
      if(["stH"].includes(id.substring(2))){
        for(let i=Math.floor(min);i<Math.ceil(max);i++){
          ticks.push(i)
          showTicks[i]=this.humStages[i]
        }
      }
      if(["zoS"].includes(id.substring(2))){
        for(let i=Math.floor(min);i<Math.ceil(max);i++){
          ticks.push(i)
          showTicks[i]=setpoints[i]?.name||(""+i)
        }
      }
      return {t:ticks,s:showTicks}
    },

    ovrTicks:(min,max,id,setpoints)=>{
      return{
        t:[...this.overrides.keys()],
        s:[...this.overrides.values()]
      }
    },
    
    makeTickVals:(min,max,id,setpoints=[])=>{
      // cl([min, max, id, setpoints])
      if(["stT","stH","zoS"].includes(id.substring(2))){return o.stageTicks(min,max,id,setpoints)}
      if(id.substring(2,4)=="co"){return o.ovrTicks(min,max,id,setpoints)}
//       cl(min,max,id,setpoints)
      if (min == 0 && max == 1) {return {t: [0, 1], s: ["OFF", "ON"]}}
      let logDif=Math.log(max-min)/Math.log(10)
      let iPart=Math.floor(logDif)
      let fPart=logDif-iPart
      let intv=(fPart<.505) ? ((fPart<.146) ? 1:2) : ((fPart<.851) ? 5:10)
      intv*=10**(iPart-1)
      let dec=(iPart<2)?2-iPart:0
      let ticks=[]
      let showTicks={}
      for(let i=min-(min%intv);i<max;i+=intv){
        if((i>=min)&&(i<=max)){
          ticks.push(i)
          showTicks[i]=(i<1000)?i.toFixed(dec):`${(i/1000).toFixed(1)}k`
        }
      }
      return {t:ticks,s:showTicks}
    },
    
    makeYAxesPos:()=>{
      let len = this.sensors.length
      if (info.showCombinedYAxis) {
          let sensorDict = {}
          this.sensors.forEach((s) => {
              if (!sensorDict[`${s.unit}${s.unitGroup}`]) {
                sensorDict[`${s.unit}${s.unitGroup}`] = true
              }
          })
          len = Object.keys(sensorDict).length
        }
      let j=0
      let pos=[]
      let gotGrid=false
      for(let i=0;i<len;i++){
        if(this.sensors[i]?.options?.showGrid&&!gotGrid){
          pos.push(60*(len))
          gotGrid=true
        }else{
          pos.push(60*(j+1))
          j=j+1
        }
      }
      return pos
//       let gotGrid=this.sensors.filter(s=>{return s.options.showGrid})
//       if(gotGrid.length){
//         cl("got grid")
//         
//       }

//       let pos=[]
//       for(let i=0;i<this.sensors.length;i++){
//         pos.push(60*(i+1))
//       }
//       return pos
    },
    
//     onChange:(type,vals)=>{
//       cl(type,vals)
//       this.props.graph.onChange(Object.assign(vals,{type:type}))
//     },
    
    addYAxes:()=>{// this needs to handle the positioning of the axes
/* the height of the test is 500 px total
 */   
//      cl("adding y axes")
//       cl(this.sensors)
//       cl(this.props.graph)
//       cl(this.props.graph?.sensors?.[0])
//       cl(this.props.graph?.sensors?.[0]?.custUnit)
      let fontSize=15
      let yPos=o.makeYAxesPos()
      let gotGrid=0
      if (this.props.graph.divId == "main-graph") {
          if (yPos.length) {
            if(o.yAxis){o.yAxis.remove()}
            o.yAxis=o.svg2.append("g")
            var rect=o.yAxis
              .append("rect")
              .attr('width', yPos[yPos.length-1])
              .attr('height', o.config.height)
              .attr('fill', `${(o.config.dark)?"#000000ff":"#ffffffff"}`)
              .attr('pointer-events', 'all')
            // process differently if combined y-axis is enabled
            // cl(info.showCombinedYAxis)
            if (info.showCombinedYAxis) {
                let sensorDict = {}
                let unitGroupCount = {}
                // Count sensors per unit+unitGroup combination
                this.sensors.forEach((s)=>{
                  if(s.yShow) {
                    let key = `${s.unit}${s.custUnit||s.unitGroup}`
                    unitGroupCount[key] = (unitGroupCount[key] || 0) + 1
                  }
                })
//                 cl(this.sensors)
                this.sensors.forEach((s,sIndex)=>{
                  let unitGroup=s.custUnit||s.unitGroup
                  if (!sensorDict[`${s.unit}${unitGroup}`]) {
                      sensorDict[`${s.unit}${unitGroup}`] = s
                      let idx = Object.keys(sensorDict).length - 1
                      let tickWidth=((s.options||{}).showGrid&&(!gotGrid))?0-info.width:0
                      gotGrid+=tickWidth
                      // cl(s)
                      s.y = d3.scaleLinear()
                        .domain([s.min, s.max]) // input 
                        .range([o.config.height, 10]); // output //Anas Added 10 for ON/OFF fix
                      if(s.yShow){
              //           cl(s)
                        let labLen=13+Math.floor(0.41*s.name.length*fontSize)
                        let labPos=(o.config.height-labLen)/2
                        let tv=o.makeTickVals(s.min,s.max,s.id,s.setpoints)
              //           cl(tv)
                        if(s.axis){s.axis.remove()}
                        s.axis=o.yAxis.append("g")
                        s.axis
                          .attr('transform', `translate(${yPos[idx]},0)`)
                          .attr("class", "y axis")
                          .attr("pointer-events","all")
                          .attr("fill","none")
                          .attr("opacity",o.config.opacity)
              //             .on("click",e=>o.onClick("c1"))
                          .call(d3.axisLeft(s.y)
                            .tickValues(tv.t)
                            .tickFormat(d=>{return tv.s[d]})
                            .tickSize(tickWidth)
                          )
                        // with Show Grid the domain path/tick lines span the plot; don't let them swallow the tooltip's mouse events
                        s.axis.selectAll(".tick line, .domain").attr("pointer-events","none")
                        s.label=s.axis.append("g")
              //           cl(this.props.graph.pageType=="viewGraph")
                        let key = `${s.unit}${unitGroup}`
                        // Only show sensor name for generic unitGroups like "Saturation" when there's only one sensor
                        let genericUnitGroups = ['Saturation', 'Generic Sensor', 'Sensor', 'None']
                        let shouldShowSensorName = (unitGroupCount[key] === 1) && genericUnitGroups.some(g => unitGroup && unitGroup.includes(g))
                        let unit=s.custUnit||s.unit
                        let labelText = shouldShowSensorName ? s.name :
                          (unitGroup) ? `${unitGroup}${unit ? ` (${unit})` : ''}` : unit
                        s.label
                          .append('text')
                          .attr('transform', `translate(-40,${labPos}) rotate(-90) `)
                          .attr("class", "y-axis-label")
                          .attr('style', `font-size: ${fontSize}px;`)// Inside Temperature - 18 chars 111 px at 15 px=.41*15*18 + 13 for color dot
                          .on("click",e=>o.onChange("yAxis",{axisOptions:sIndex, divId: this.props.graph.divId}))
                          .text(labelText)
                      }
                  }
                })
            } else {
                this.sensors.forEach((s,sIndex)=>{
                  let tickWidth=((s.options||{}).showGrid&&(!gotGrid))?0-info.width:0
                  gotGrid+=tickWidth
          //         cl(s)
                  s.y = d3.scaleLinear()
                    .domain([s.min, s.max]) // input 
                    .range([o.config.height, 10])
                    ; // output //Anas Added 10 for ON/OFF fix
                  if(s.yShow){
                    // cl(s)
                    let labLen=13+Math.floor(0.41*s.name.length*fontSize)
                    let labPos=(o.config.height-labLen)/2
                    let tv=o.makeTickVals(s.min, s.max,s.id,s.setpoints)
          //           cl(tv)
                    if(s.axis){s.axis.remove()}
                    s.axis=o.svg2.append("g")
                    s.axis
                      .attr('transform', `translate(${yPos[sIndex]},0)`)
                      .attr("class", "y axis")
                      .attr("opacity",o.config.opacity)
          //             .on("click",e=>o.onClick("c1"))
                      .call(d3.axisLeft(s.y)
                        .tickValues(tv.t)
                        .tickFormat(d=>{return tv.s[d]})
                        .tickSize(tickWidth)
                      )
                    s.label=s.axis.append("g")
          //           cl(this.props.graph.pageType=="viewGraph")
                    let curs=(this.props.graph.pageType=="viewGraph")?null:"pointer"
//                     cl(s.name)
                    s.label
                      .append('text')
                      .attr('transform', `translate(-40,${labPos}) rotate(-90) `)
                      .attr("class", "y-axis-label")
                      .attr('style', `font-size: ${fontSize}px;`)// Inside Temperature - 18 chars 111 px at 15 px=.41*15*18 + 13 for color dot
                      .on("click",e=>o.onChange("yAxis",{axisOptions:sIndex, divId: this.props.graph.divId}))
                      .text(s.name)
                    s.circ=s.axis.append("g").append("circle")
                      .attr("cx", -45)
                      .attr("cy", labPos-10)
                      .attr("r", 5)
                      .attr("fill",s.color)
                  }
                })
            }
          }
      } else if (this.props.graph.divId == "event-timeline") {
        if (yPos.length) {
            if(o.yAxisE){o.yAxisE.remove()}
            o.yAxisE=o.svg2.append("g")
            var rect=o.yAxisE
              .append("rect")
              .attr('width', yPos[yPos.length-1])
              .attr('height', o.config.height)
              .attr('fill', `${(o.config.dark)?"#000000ff":"#ffffffff"}`)
              .attr('pointer-events', 'all')
            // cl("drawing y axis of event timeline")
            // only label is events, it opens the events checkbox
            // need default event to act as axis
            // cl(yPos[this.sensors.length - 1])
            // cl(JSON.stringify(this.events))
            this.events.forEach((s,sIndex)=>{
            // this.sensors.forEach((s,sIndex)=>{
              if (s.id == "default") {
                  let tickWidth=((s.options||{}).showGrid&&(!gotGrid))?0-info.width:0
                  gotGrid+=tickWidth
          //         cl(s)
          //         cl(s.min,s.max)
  //                 cl(s.min,s.max)
  //                 cl(o.config.height)
                  s.y = d3.scaleLinear()
                    .domain([s.min, s.max]) // input 
                    .range([o.config.height, 0]); // output 
          //           cl(s)
                  // label is now the cog icon
                // let labLen=13+Math.floor(0.41*6*fontSize) // 6 is len of "events"
                // let labPos=(o.config.height-labLen)/2
                // cl(s)
                let tv=o.makeTickVals(0,0,s.id)
                if(s.axis){s.axis.remove()}
                s.axis=o.svg2.append("g")
                s.axis
                  .attr('transform', `translate(${yPos[yPos.length - 1] || 60 },0)`) // only one y-axis
                  .attr("class", "y axis")
                  .attr("opacity",o.config.opacity)
      //             .on("click",e=>o.onClick("c1"))
                  .call(d3.axisLeft(s.y)
                    .tickValues(tv.t)
                    .tickFormat(d=>{return tv.s[d]})
                    .tickSize(tickWidth)
                  )
                s.label=s.axis.append("g")
      //           cl(this.props.graph.pageType=="viewGraph")
                // s.label
                //   .append('text')
                //   .attr('transform', `translate(-40,${labPos}) rotate(-90) `)
                //   .attr('style', `font-size: ${fontSize}px; fill:${(o.config.dark)?"white":"black"};cursor:${curs}`)// Inside Temperature - 18 chars 111 px at 15 px=.41*15*18 + 13 for color dot
                //   .on("click",e=>o.onChange("yAxis",{showEventOptions:1, divId: this.props.graph.divId}))
                //   .text("Events")
                fontSize = 25
                s.label
                  .append('text')
                  .attr('transform', `translate(-20,${o.config.height/2})`)
                  .attr("class", "material-icons button")
                  .attr('style', `font-size: ${fontSize}px;`)// Inside Temperature - 18 chars 111 px at 15 px=.41*15*18 + 13 for color dot
                  .on("click",e=>o.onChange("yAxis",{showEventOptions:1, divId: this.props.graph.divId}))
                  .text("settings")
                // s.label
                //   .append('g')
                //   .append('path')
                //   .attr("d", cog_d)
                //   .append("rect")
                //   .attr('transform', `translate(-40,${labPos})`)
                //   .attr("y", 72.72)
                //   .attr("width", 100)
                //   .attr("height", 2)
                  // s.label
                  //     .append('text')
                  //     .attr('transform', `translate(-40,${labPos})`)
                  //     .attr("class", "material-icons")
                  //     .attr('style', `font-size: ${fontSize}px; fill:${(o.config.dark)?"white":"black"};cursor:${curs}`)// Inside Temperature - 18 chars 111 px at 15 px=.41*15*18 + 13 for color dot
                  //     .on("click",e=>o.onChange("yAxis",{showEventOptions:1, divId: this.props.graph.divId}))
                  //     .text("settings")
                  }
            })
        }
      }
    },
    
    makeHandleGradient:()=>{
      o.hGrad=o.defs.append("linearGradient")
        .attr("id", `handleGradient`)
        .attr("x1", "0%")
        .attr("x2", "100%")
        .attr("y1", "0%")
        .attr("y2", "0%");
        o.hGrad.append("stop")
        .attr("class", "start")
        .attr("offset", "0%")
        .attr("stop-color", "black")
        .attr("stop-opacity", 0);
        o.hGrad.append("stop")
        .attr("class", "end")
        .attr("offset", "100%")
        .attr("stop-color", "black")
        .attr("stop-opacity", 0.2);
    },
    
    addGradients:(s,i)=>{
//       cl("addgrad")
//       cl(s.color)
      s.grad=o.defs.append("linearGradient")
        .attr("id", `svgGradient${i}`)
        .attr("x1", "0%")
        .attr("x2", "0%")
        .attr("y1", "0%")
        .attr("y2", "100%");
        s.grad.append("stop")
        .attr("class", "start")
        .attr("offset", "0%")
        .attr("stop-color", s.color)
        .attr("stop-opacity", .25);
        s.grad.append("stop")
        .attr("class", "end")
        .attr("offset", "50%")
        .attr("stop-color", s.color)
        .attr("stop-opacity", 0);

    },
    
    addShades:()=>{
//       cl("addShades")
      this.sensors.forEach((s,i)=>{
        var line=d3.line()
          .x((d, i)=> { return o.x(d.t); }) // set the x values for the line generator
          .y((d, j)=> { return s.y(d.v); })
              // if (o.getCurveType(s) == d3.curveStepAfter) {
              //     // cl(d.v)
              //     // cl(s.data[i])
              //     // cl(s.data[i-1])
              //     // cl(s.data[i+1])
              //     return s.y(Math.round(d.v))
              //     // if (s.data[j+1]) {
              //     //     return (d.v > s.data[j+1].v) ? s.y(1) : s.y(0)
              //     // }
              //     // if (s.data[j-1]) {
              //     //     return (d.v < s.data[j-1].v) ? s.y(0) : s.y(1)
              //     // }
              //     // return s.y(d.v ? 1 : 0)
              // } else {
              //     return s.y(d.v)
              // }
          // }) // set the y values for the line generator 
          .curve(o.getCurveType(s)) // apply smoothing to the line
        if(s.shade){
//           cl("remove")
          s.shade.remove()
          
        }
        s.shade=o.shadeParent.append("path")
        var shade=s.data.slice(0)
        if(shade.length){
          let last=shade.length-1
//           cl(shade)
          shade.push({t:shade[last].t,v:s.min},{t:shade[0].t,v:s.min})
          s.shade
            .datum(shade) // 10. Binds data to the line 
            .attr("class", "line-shade") // Assign a class for styling 
            .attr("fill", `url(#svgGradient${i})`) // Assign a class for styling 
  //           .attr("stroke", s.color) // Assign a class for styling 
            .attr("d", line) // 11. Calls the line generator 
        }
      })
    },

    getEventColor:(id, d=null)=>{
        switch (id) {
            case "grj":
                return "#88CC88"
            case "adl":
                return "#1976d2"
            case "cte":
                return "#1976d2"
            case "ala":
                // get alarm level
                if (d?.level<=3) {
                    return d?.ended ? "#49a42e" : "#df568b"
                } else {
                    return d?.ended ? "#5d5b59" : "#e2812d"
                }
            // case "alr":
            //     // get alarm level
            //     if (d?.level<=3) {
            //         return "#49a42e"
            //     } else {
            //         return "#5d5b59"
            //     }
            default:
                return "#88CC88"
        }
    },

    makeImagePath:(id)=>{
        // cl(id.substring(id.length - 3))
        // if video, set timestamp 
        let url = `${constant.expressUrl}/usa/images/uploads/${id[0]}/${id[1]}/${id[2]}/${id.substr(3)}`
        if (id.substring(id.length - 3) == "mp4") url += "#t=0.001"
        // cl(`${constant.expressUrl}/usa/images/uploads/${id[0]}/${id[1]}/${id[2]}/${id.substr(3)}`)
        return url
    },

    getEventHeight:(v)=>{
        let count = (v + 2) / 5
        return count * 20
    },

    makeEventClick:(e, s, d, timeDict)=>{
      let t = Math.round(d.t/10000) * 10000
      let data = s.data.filter((da) => {return t == (Math.round(da.t/10000) * 10000)})
      o.onChange("eventClick",{
        e:e, type: s.id, data:data
      })
    },

    makeEventHeight:(s, d, timeDict)=>{
      let t = Math.round(d.t/10000) * 10000
      if (!timeDict[t] || !timeDict[t][s.id]) {
        timeDict[t] = {}
        timeDict[t][s.id] = 1
        // all ids at this timestamp share vertical space
        if (!timeDict[t]["height"]) {
          timeDict[t]["height"] = 10
        } else {
          timeDict[t]["height"] += 8
        }
        o.maxHeight = Math.max(o.maxHeight,timeDict[t]["height"])
        return s.y(timeDict[t]["height"])
      } else {
        return -1000
      }
    },

    makeEventText: (s, d) => {
      // return number of entries on this icon
      let t = Math.round(d.t/10000) * 10000
      let data = s.data.filter((da) => {return t == (Math.round(da.t/10000) * 10000)})
      switch (s.id) {
        case "grj":
          if (data.length > 1) {
            return `${data.length} Grow Journals\n${dateToDisplayDate(new Date(t),"mm/dd/yyyy h:mm:ss ap")}`
          } else {
            return `Grow Journal\n${dateToDisplayDate(d.t,"mm/dd/yyyy h:mm:ss ap")}`
          }
        default:
          if (data.length > 1) {
            return `${data.length} ${s.id} Entries\n${dateToDisplayDate(new Date(t),"mm/dd/yyyy h:mm:ss ap")}`
          } else {
            return `${s.id} Entry\n${dateToDisplayDate(d.t,"mm/dd/yyyy h:mm:ss ap")}`
          }
      }
    },

    makeEventDMs:()=>{
        let timeDict = {}
        // cl(this.events)
        this.events.forEach((s,i)=>{
              // do different events for gje, adl, ctes
            if (s.id != "default") {
              if (s.dmPath) {
                s.dmPath.remove()
              }
              s.dmPath=o.dotsParent.append("g")
              // get events with and without images
              let events = s.data
              let mEvents = []
              if (s.id == "grj") {
                  events = s.data.filter((s)=> {return s.data.images?.length == 0})
                  mEvents = s.data.filter((s)=> {return s.data.images?.length})
              }
              let color = o.getEventColor(s.id)
              // regular events
              // cl(color)
              // cl(events)
              if (mEvents.length) {
                let imageExts=["apng", "avif", "gif", "jpg", "jpeg", "png", "svg", "webp"]
                let videoExts=["mp4","mov"]
                let iEvents = mEvents.filter((d)=>{return imageExts.includes(d.data.images[0].id.substring(d.data.images[0].id.lastIndexOf(".") + 1).toLowerCase())})
                let vEvents = mEvents.filter((d)=>{return videoExts.includes(d.data.images[0].id.substring(d.data.images[0].id.lastIndexOf(".") + 1).toLowerCase())})
                let oEvents = mEvents.filter((d)=>{return !videoExts.includes(d.data.images[0].id.substring(d.data.images[0].id.lastIndexOf(".") + 1).toLowerCase()) 
                && !imageExts.includes(d.data.images[0].id.substring(d.data.images[0].id.lastIndexOf(".") + 1).toLowerCase())})
                
                // events with images
                s.dmPath.selectAll("event-img")
                .data(iEvents)
                .enter().append("svg:image") // Uses the enter().append() method

                .on("click",(e,d)=>{o.makeEventClick(e, s, d, timeDict)}) // bring up gj popup
                .on("mouseover", function (e, d) {
                  d3.select(this).attr('style', `opacity:0.5;cursor:pointer`);
                })
                .on("mouseout", function (e, d) {
                  d3.select(this).attr('style', `opacity:1;cursor:pointer`);
                })
                .attr("id","dataMarker")
                .attr("xlink:href", (d)=>{return o.makeImagePath(d.data.images[0].id)})
                .attr("x", (d, i)=>{return o.x(d.t) - 14})
                .attr("y", (d)=>{return o.makeEventHeight(s, d, timeDict)})
                .attr("class", "image") // Assign a class for styling
                .attr("style", "cursor:pointer") // Assign a class for styling
                .attr('width', 30)
                .attr('height', 30)
                .attr('marginTop', -5)
                .append("svg:title")
                .text((d,i)=>{return o.makeEventText(s, d)})

                // events with video
                s.dmPath.selectAll("event-img")
                .data(vEvents)
                .enter().append('text')
                .on("click",(e,d)=>{o.makeEventClick(e, s, d, timeDict)}) // bring up gj popup
                .attr("x", (d, i)=>{return o.x(d.t) - 14})
                .attr("y", (d)=>{return o.makeEventHeight(s, d, timeDict)})
                .on("mouseover", function (e, d) {
                  d3.select(this).attr('style', `opacity:0.5;cursor:pointer`);
                })
                .on("mouseout", function (e, d) {
                  d3.select(this).attr('style', `opacity:1;cursor:pointer`);
                })
                .attr("id","dataMarker")
                .attr("class", "material-icons")
                .attr('style', `font-size: 25px; fill:${(o.config.dark)?"white":"black"};cursor:pointer`)
                .text("play_circle_outline")
                .append("svg:title")
                .text((d,i)=>{return o.makeEventText(s, d)})
                // events with other attachments
                s.dmPath.selectAll("event-img")
                .data(oEvents)
                .enter().append('text')
                .on("click",(e,d)=>{o.makeEventClick(e, s, d, timeDict)}) // bring up gj popup
                .attr("x", (d, i)=>{return o.x(d.t) - 14})     
                .attr("y", (d)=>{return o.makeEventHeight(s, d, timeDict)})
                .on("mouseover", function (e, d) {
                  d3.select(this).attr('style', `opacity:0.5;cursor:pointer`);
                })
                .on("mouseout", function (e, d) {
                  d3.select(this).attr('style', `opacity:1;cursor:pointer`);
                })
                .attr("id","dataMarker")
                .attr("class", "material-icons")
                .attr('style', `font-size: 25px; fill:${(o.config.dark)?"white":"black"};cursor:pointer`)// Inside Temperature - 18 chars 111 px at 15 px=.41*15*18 + 13 for color dot
                .text("file_present")
                .append("svg:title")
                .text((d,i)=>{return o.makeEventText(s, d)})
            }
            if (events.length) {
              // calculate time
                switch (s.id) {
                    case "ala":
                    // case "alr":
                         s.dmPath.selectAll("event-dot")
                            .data(events)
                            .enter()
                            .append("text")
                            .on("click",(e,d)=>{o.makeEventClick(e, s, d, timeDict)}) // bring up gj popup
                            .on("mouseover", function (e, d) {
                              d3.select(this).attr('style', `opacity:0.5;cursor:pointer;fill:${(o.config.dark)?"#ffffff00":"#00000000"}`);
                            })
                            .on("mouseout", function (e, d) {
                              d3.select(this).attr('style', `opacity:1;cursor:pointer;fill:${(o.config.dark)?"#ffffff00":"#00000000"}`);
                            })
                            .attr("class", (d)=> {
                              return "material-icons"
                            }) // Assign a class for styling
                            .attr("id", (d)=> {return `data marker`})
                            .attr("x", (d, i)=>{ 
                              return o.x(d.t) - 14})     
                            .attr("y", (d)=>{return o.makeEventHeight(s, d, timeDict)})
                            .attr("style", d=> {
                              return `font-size: 25px; fill:${(o.config.dark)?"#ffffff00":"#00000000"};cursor:pointer`
                            }) // Assign a class for styling 
                            // TODO use different color based on level of alarm
                            .attr("stroke", d=> {return o.getEventColor(s.id, d.data)}) // Assign a class for styling 
                            .attr("r", d=>{return 5})
                            .text((d) => {
                              return (d.data.ended) ? "notifications_off" : "notification_important"
                            })
                            .append("svg:title")
                            .text((d,i)=>{return o.makeEventText(s, d)})
                        break
                    default:
                         s.dmPath.selectAll("event-dot")
                            .data(events)
                            .enter()
                            .append("circle")
                            .on("click",(e,d)=>{o.makeEventClick(e, s, d, timeDict)}) // bring up gj popup
                            .on("mouseover", function (e, d) {
                              d3.select(this).attr('style', `opacity:0.5;cursor:pointer`);
                            })
                            .on("mouseout", function (e, d) {
                              d3.select(this).attr('style', `opacity:1;cursor:pointer`);
                            })
                            .attr("class", "dot")
                            .attr("id", (d)=> {
                                // cl(d)
                                if (s.id != "grj") {
                                    return `{"cmd":"graph", "type": "sensor", "s": "${s.s}", "id": "${s.id}", "t": ${Math.floor(d.t.getTime())}, "v": ${JSON.stringify(d.data)}}`
                                } else {
                                    return `data marker`
                                }  
                            })
                            .attr("cx", (d, i)=>{ 
                              // cl(d)
                              return o.x(d.t)})
                            .attr("cy", (d)=>{return o.makeEventHeight(s, d, timeDict)})
                            .attr("fill", d=>{return color}) // Assign a class for styling 
                            .attr("style", "cursor:pointer")
                            .attr("stroke", (o.config.dark)?"white":"black") // Assign a class for styling 
                            .attr("r", d=>{return 5})
                            .append("svg:title")
                            .text((d,i)=>{return o.makeEventText(s, d)})
                        break
                }
            }
          }
      })
        if (o.config.height < o.maxHeight && this.svgDiv.current) {
            o.config.height = o.maxHeight + 7
            this.svgDiv.current.setAttribute("style",`height: ${o.config.height}`)
            if (o.svg) o.svg.remove()
            o.makeSvg(info.svg)
            o.checkNewData(o.dispFrom,o.dispTo)
        }


    },

    addThreshold:()=>{
//       cl("addThreshold")
      if(this.props.graph.divId!="main-graph"){return}
//       cl(this.props.graph.divId)
      let gr=this.props.graph
      this.sensors.forEach((s,i)=>{
//         cl(this.props.graph)
        if(s.threshold){
//           cl(s.threshold)
          let data=[gr.from,gr.to].map(t=>{return{
            t:new Date(1000*t),
            v:s.threshold
          }})
//           cl(s)
//           cl(data)
//           cl(s.data)
          if(s.thPath){s.thPath.remove()}
          var line=d3.line()
          .x((d, i)=> { return o.x(d.t)}) // set the x values for the line generator
          .y((d, j)=> { return s.y(d.v)})
          s.thPath=o.threshParent.append("path")
          s.thPath
            .datum(data) // 10. Binds data to the line
            .attr("class", "line") // Assign a class for styling
            .attr("fill", "none") // Assign a class for styling
            .attr("stroke", s.color) // Assign a class for styling
            .attr("stroke-width", 3)
            .attr("d", line) // 11. Calls the line generator
        }
      })
    },
    
    addDMs:()=>{
//       cl(this.props.graph.divId)
      if(this.props.graph.divId=="guide-graph"){return}
      if(this.props.graph.divId=="event-timeline"){
          // cl(this.events)
          o.makeEventDMs()
      } else {

//       cl(info.showDM)
//       cl(`add: ${this.props.graph.divId}`)
//       cl(s.dmPath)
//       if(s.dmPath){
//         s.dmPath.remove()
//         cl("remove")
//       }
//       s.dmPath=o.pathsParent.append("DM")
      let humStages = this.humStages
      let tempStages = this.tempStages
      this.sensors.forEach((s,i)=>{

        if(s.dmPath){
//           cl("remove")
          s.dmPath.remove()
          
        }
        if(info.showDM){
          s.dmPath=o.dotsParent.append("g")
  //         cl(Math.floor(s.data[0].t.getTime()/1000))
          s.dmPath.selectAll("dot")
            .data(s.data)
            .enter().append("circle") // Uses the enter().append() method
            // .on("click",(e,d)=>o.onChange("gjClick",{e:e,gj:d.gj}))
            .attr("class", "dot") // Assign a class for styling
            // .attr("id","dataMarker")
            .attr("id", (d)=> {
                // cl(d)
                // return `{"cmd":"graph", "type": "sensor"}`
                let val
                if(["stT"].includes(s.id.substring(2))){
                    val = tempStages[Math.round(d.v)]
                }
                else if(["stH"].includes(s.id.substring(2))){
                    val = humStages[Math.round(d.v)]
                }
                else if(["zoS"].includes(s.id.substring(2))){
                    val = s.setpoints[Math.round(d.v)].name
                } else {
                    val = d.v
                }
                return `{"cmd":"graph", "type": "sensor", "s": "${s.s}", "zInd": ${s.z}, "id": "${s.id}", "c": ${s.c}, "t": ${Math.floor(d.t.getTime())}, "v": ${val}}`
            })
            .attr("cx", (d, i)=>{ 
              // cl(d)
              return o.x(d.t) })
            .attr("cy", (d, i)=>{
                // cl(s.data)
                // cl([d, j, s.data[j]])
                // cl(this.sensors[i])
                // cl(this.sensors[i].data[j])
                return s.y(d.v) })
            // .attr("fill", d=>{return (d.gj)?"#88CC88":s.color}) // Assign a class for styling 
            .attr("fill", d=>{return s.color}) // Assign a class for styling 
//             .style("pointer", "cursor"
            .attr("style", "cursor:pointer") // Assign a class for styling 
//             .attr("onClick", d=>{cl(d)}) // Assign a class for styling 
            .attr("stroke", s.color) // Assign a class for styling 
            // .attr("r", d=>{return (d.gj)?10:5})
            .attr("r", d=>{return 5})
            .append("svg:title")
            .text((d,i)=>{
                let val
                if(["stT"].includes(s.id.substring(2))){
                    val = tempStages[Math.round(d.v)]
                }
                else if(["stH"].includes(s.id.substring(2))){
                    val = humStages[Math.round(d.v)]
                }
                else if(["zoS"].includes(s.id.substring(2))){
                    val = s.setpoints[Math.round(d.v)].name
                } else {
                    val = d.v
                }
                return `${val}${s.unit}\n${dateToDisplayDate(d.t,"mm/dd/yyyy h:mm:ss ap")}\n${s.name}`
            })
  //         s.dmPath.remove()
//           s.dmPath.selectAll("dot")
//             .on("click",e=>{cl(e);/* o.onChange("gjClick",{gj:d.gj})*/})
        }
      })

      }
    },
    
    getCurveType:(s)=>{
      // cl(s.id)
      let equipment = s.id.substr(2, 1) == "c"
      let auxVals=["aa","av","ap"].includes(s.id.substring(2,4))
      return (equipment || auxVals || ["stT","stH","spH","spC","spU","spD","alL","alH","zoS"].includes(s.id.substring(2)))?d3.curveStepAfter:d3.curveMonotoneX
    },

    addPaths:()=>{// adds the lines
//       cl(`add paths ${this.props.graph.divId}`)
//       cl(this.sensors)
//       cl(this.props.graph.divId)
//       cl(`add ${this.sensors.length} paths to ${this.props.graph.divId}`)
      let dict = {}
      this.sensors.forEach(s=>{
//         cl(Math.floor(s.data[0].t.getTime()/1000))
        // cl(s)
//         cl(s.data)
        if(s.path){
//           cl(`remove ${s.color} path from ${this.props.graph.divId}`)
          s.path.remove()
//             .datum(s.data) // 10. Binds data to the line 
//             .attr("class", "line") // Assign a class for styling 
//             .attr("fill", "none") // Assign a class for styling 
//             .attr("stroke", s.color) // Assign a class for styling 
//             .attr("stroke-width", 3)
//             .attr("d", line) // 11. Calls the line generator 
        }
//         if(s.dmPath){s.dmPath.remove()}
//         s.dmPath=null
//         let curve=(["stT","stH","spH","spC","spU","spD","alL","alH",
//           "c00","c01","c02","c03","c04","c05","c06","c07","c08","c09","c10","c11"].includes(s.id))?d3.curveStepAfter:d3.curveMonotoneX
        var line=d3.line().x((d, i)=>o.x(d.t)) // set the x values for the line generator
          .y((d, j)=> { 
              // special check for stH, need to swap 0 and 1
              if (["stH"].includes(s.id.substring(2))) {
                if (d.v == 0) {
                  d.v = 1
                } else if (d.v == 1) {
                  d.v = 0
                }
              }
              // check dictionary and place higher if necessary to prevent overlap
              if (dict[`${d.t}-${d.v}`]) {
                dict[`${d.t}-${d.v}`] += 1
                // cl(`${d.t}-${d.v}`)
                // cl(dict[`${d.t}-${d.v}`])
                // scalar bump is based on 0-100 range
                // cl(d.v + ((dict[`${d.t}-${d.v}`] - 1) * (.4 * ((s.max - s.min) / 100))))
                return s.y(d.v + ((dict[`${d.t}-${d.v}`] - 1) * (.4 * ((s.max - s.min) / 100))))
              }
              dict[`${d.t}-${d.v}`] = 1
              return s.y(d.v);
             }) 
              // if (o.getCurveType(s) == d3.curveStepAfter) {
              //     return s.y(d.v)
              //     // if next actual point
              //     if (s.data[j+1]) {
              //         return (d.v < s.data[j+1].v) ? s.y(0) : s.y(1)
              //     }
              //     if (s.data[j-1]) {
              //         return (d.v > s.data[j-1].v) ? s.y(0) : s.y(1)
              //     }
              //     return s.y(Math.round(d.v))
              //     // return s.y((s.data[i-1]?.v||0) ? 1 : 0)
              // } else {
              //     return s.y(d.v)
              // }
           // }) // set the y values for the line generator 
//           .curve(d3.curveMonotoneX) // apply smoothing to the line
          .curve(o.getCurveType(s)) // apply smoothing to the line
//         cl(s.data)
        s.path=o.pathsParent.append("path")
//         cl(s.color)
//         cl(s.data.map(d=>{return d.v}))
//         cl(`add ${s.color} path from ${this.props.graph.divId}`)
//         cl(s.color)
//         cl(s.data)
//         s.data.forEach((d,i)=>{if(isNaN(d.v)){d.v=0/*s.data[i-1].v*/}})
//         cl(s)
        s.path
          .datum(s.data) // 10. Binds data to the line 
          .attr("class", "line") // Assign a class for styling
          .attr("fill", "none") // Assign a class for styling
          .attr("stroke", s.color) // Assign a class for styling
          .attr("stroke-width", 3)
          .attr("d", line) // 11. Calls the line generator
//         cl(s.path)
      })
    },

//     addPath:(svg)=>{
//       var line=o.makeLine()
//       if(o.path){o.path.remove()}
//       o.path=o.pathsParent.append("path")
//       o.path
//         .datum(o.config.dataset2) // 10. Binds data to the line 
//         .attr("class", "line") // Assign a class for styling 
//         .attr("fill", "none") // Assign a class for styling 
//         .attr("stroke", "#FF00FF") // Assign a class for styling 
//         .attr("d", line) // 11. Calls the line generator 
//     },

//     addShade:(svg)=>{
//       var line=o.makeLine()
//       var shade=o.config.dataset2.slice(0)
//       let last=shade.length-1
// //       cl(shade[0])
// //       cl(shade[last])
//       shade.push({t:shade[last].t,v:18},{t:shade[0].t,v:18})
//       o.path=svg.append("path")
//       o.path
//         .datum(shade) // 10. Binds data to the line 
//         .attr("class", "line")
//         .attr("fill", "#FFCCFF")
//         .attr("stroke", "#FF00FF")
//         .attr("d", line) // 11. Calls the line generator 
//     },
    
//     dragType: null,
//     
// //     mouseOver:()=>{
// //       cl("m")
// //     },
//     
//     mouseMove:()=>{
//       cl(o.dragType)
//     },
//     
//     mouseDown:(type,e)=>{
//       o.dragType=type
//       cl(type)
// //       cl(a)
// //       cl(b)
//     },
//     
//     mouseUp:()=>{
//       o.dragType=null
//     },
    
    onChange:(type,vals)=>{
//       cl(vals)
//       cl(type,vals)
      this.props.graph.onChange({type: type, vals:vals})
    },
    

    
    dragHandler: d3.drag()
    .on("start", function (e) {
//       cl("showTimePeriod")
      if(!o.config.that.props.graph.showTimePeriod){
        o.handleId=this.id
          var current = d3.select(this);
          o.deltaX = current.attr("x") - e.x;//current.attr("x")
      }
    })
    .on("drag", function (e) {
      if(!o.config.that.props.graph.showTimePeriod){// if this is the guide graph

        //         cl("drag")
//         cl(o.handleId)
        let newX=e.x + o.deltaX
        let oLeft=o.left
        let oRight=o.right
        // cl([info.width, o.config, newX, oLeft, oRight])

//         cl(oLeft,oRight)
        if(o.handleId=="center"){
          let dif=newX-o.left
          if(((dif>0)&&(o.right+dif<o.config.width))||
            ((dif<0)&&(o.left+dif>0))){
              o.left+=dif
              o.right+=dif
              o.boxL.attr("x", o.left)
              o.boxR.attr("x", o.right-5)
            }
        }else{
          if(o.handleId=="left"){
//             cl("left")
            if((newX>=o.right-20)||(newX<0)){return}
            o.left=newX
            o.boxL.attr("x", o.left)
          }else{// right
            if((newX<o.left+20)||(newX>o.config.width)){return}
            o.right=newX+5
            o.boxR.attr("x", o.right-5)
          }
        }
        let sFrom=o.xValToFromPos(o.left,false)
        let sTo=o.xValToFromPos(o.right,false)
//         cl(sTo,sFrom)
        if(sTo-sFrom>o.maxZoom || // not maxed yet, or just sliding in the middle
        (((o.right-o.left)>=(oRight-oLeft))&&(o.left>0)&&(o.right<o.config.width))  ){
//           cl("not max zoom")
          info.sFrom=sFrom
          info.sTo=sTo
        }else{
//           cl("restore")
          o.left=oLeft
          o.right=oRight
//           cl(`box l: ${o.left}`)
          o.boxL.attr("x", o.left)
          o.boxR.attr("x", o.right-5)
//           cl(o.left)
        }
//         cl(o.left,o.right)
        if(info.sFrom<info.from){
          info.sFrom=info.from
          let oldLeft=o.left
          o.left=o.xValToFromPos(info.sFrom,true)
          o.deltaX+=(o.left-oldLeft)
//           cl(`box l: ${o.left}`)
          o.boxL.attr("x", o.left)
        }
        if(info.sTo>info.to){// need to make sure the box doesn't shrink too much, too
          // cl(info.to,info.sTo)
  //         cl(o.right)
  //         cl(o.xValToFromPos(info.sTo,true))
          info.sTo=info.to
  //         cl(info.sTo)
          o.right=o.xValToFromPos(info.sTo,true)
          if((o.right-o.left)<20){
            o.left=o.right-20
//             cl(`box l: ${o.left}`)
            o.boxL.attr("x", o.left)
          }
          o.boxR.attr("x", o.right-5)
        }
  //       cl(info)
  //       cl(this.props)
  //       cl(o)
//         cl(info)
        // cl("select change")
        o.onChange("selectChange",{fromVal:info.sFrom, toVal:info.sTo})
//         d3.select(this).attr("x", newX)
  //       cl(o.left,o.right)
        o.box
          .attr('x',o.left+5)
          .attr("width", o.right-o.left-5)
//         o.boxC
//           .attr('x',o.left+5)
//           .attr("width", o.right-o.left-5)
//         cl(o.left)
      }
        
    }),
    
    left:50,
    right:100,
    handleId: null,
    
    xValToFromPos:(v,toFlag)=>{
      v=Math.round(v)
      let gr=this.props.graph
      let x0=o.minTime//gr.from
      let d0=o.maxTime-o.minTime//gr.to-gr.from
      let x1=0
      let d1=o.config.width
      if(toFlag){// to pixel position
        return Math.round(x1+d1*(v-x0)/d0)
      }else{
        let v1=Math.round(x0+d0*(v-x1)/d1)
//         let v0=Math.round(x1+d1*(v1-x0)/d0)
//         cl(v,v0,v1)
        return v1
      }
    },
    
    deleteSensors:(oldSensors, newSensors)=>{
      for(let i=oldSensors.length-1;i>=0;i--){
        let s=oldSensors[i]
        if(!newSensors.includes(s)){
          let se=this.sensors[i]
          if(se?.path){
            se.path.remove()}
          if(se?.shade){
            se.shade.remove()}
          if(se?.dmPath){
            se.dmPath.remove()}
          this.sensors.splice(i,1)
        }
      }
//       cl(this.sensors)
    },
    
    addSensors:(oldSensors, newSensors,vals)=>{
      let needNewData=false
//       cl(newSensors)
      // prevent dupe colors
      let colorDict = {}
      this.sensors.forEach((s,i)=>{
        colorDict[s.color] = true
      })
      newSensors.forEach((s,i)=>{
        if(!oldSensors.includes(s)){
          let v=vals[i]
          cl(v)
          let color = v.color
          let idx = i
          while (colorDict[color] && (idx < this.colorArr.length)) {
            idx += 1
            color = this.colorArr[idx % this.colorArr.length]
          }
          colorDict[color] = true
          let s2={
            c:v.c,
            s:v.s,
            z:v.z,
            i:v.i,
            yShow:v.yShow,
            name:v.name,
            custUnit:v.custUnit,
            color:color,
            unit:v.unit || "",
            unitGroup:v.unitGroup || "",
            parmType:v.parmType || "",
            id:v.id,
            max:v.max,
            min:v.min,
            setpoints:v.setpoints || []
          }
          if(v.options){
            s2.color=v.options.color
            s2.min=v.options.min 
            s2.max=v.options.max
            s2.mode=v.options.mode
            s2.unit=v.options.unit
            s2.options=v.options
          }
          this.sensors.push(s2)
          needNewData=true
        }
      })
      return needNewData
    },
    
    deleteEvents:(oldEvents, newEvents)=>{
      for(let i=oldEvents.length-1;i>=0;i--){
        let s=oldEvents[i]
        // cl(s)
        // if(!newEvents.includes(s) && s != "default"){
        if(s != "default"){
          let se = this.events[i]
          // cl(se)
          // should remove dots???
          if(se?.dmPath){se.dmPath.remove()}
          this.events.splice(i,1)
        }
      }
//       cl(this.sensors)
    },
    
    addEvents:(oldEvents, newEvents,vals)=>{
      let needNewData=false
      newEvents.forEach((s,i)=>{
        // cl(s)
        // if(!oldEvents.includes(s)){
          let v=vals[i]
//           cl(v)
          let s2={
            s:v.s,
            z:v.z,
            yShow:v.yShow,
            name:v.name,
            color:v.color,
            id:v.id,
          }
          if(v.options){
            s2.color=v.options.color
            s2.min=v.options.min 
            s2.max=v.options.max
            s2.mode=v.options.mode
            s2.unit=v.options.unit
            s2.options=v.options
          }
//           cl(s2)
          this.events.push(s2)
          needNewData=true
        // }
      })
      // cl(needNewData)
      // cl(this.events)
      return needNewData
    },
    
    makeGradients:()=>{
      o.svg.selectAll("defs").remove()
      o.defs=o.svg.append("defs")
      this.sensors.forEach((s,i)=>{
        // cl(s.color)
        o.addGradients(s,i)
        
      })
      if(info.showSelect){
        o.makeHandleGradient()
      }
      
    },
    
    onNewTimePeriod:async(vals)=>{// vals.startDate and endDate are Date objects
// this needs to update the info.from and to, also
      cl("on new time period")
//       cl(vals)
//       cl(info)
      // cl(`New Time Period for ${this.graphName}`)
      info.from=vals.fromTime
      info.sFrom=(vals.fromSelect)?vals.fromSelect:vals.fromTime
      info.to=vals.toTime
      info.sTo=(vals.toSelect)?vals.toSelect:vals.toTime
      info.showDM=false// why?
      info.showVBar=false// why?
      info.showMobileView=false
      info.showZoomBar=true
      
      if(typeof(vals.dataMarkers)!="undefined"){
        info.showDM=vals.dataMarkers
      }
      if(typeof(vals.vBar)!="undefined"){
        info.showVBar=vals.vBar
      }
      if(typeof(vals.mobileView)!="undefined"){
        info.showMobileView=vals.mobileView
      }
      if(typeof(vals.zoomBar)!="undefined"){
        info.showZoomBar=vals.zoomBar
      }
//       cl(info)

      if(vals.sensors){o.setNewSensors(vals.sensors)}
//       cl(this.props.graph.showSelect)
      o.makeGradients()
//       this.sensors.forEach((s,i)=>{
//         cl(s.color)
//         o.addGradients(s,i)})
      if(!this.props.graph.showSelect){
        info.from=info.sFrom
        info.to=info.sTo
      }
      // cl("on new time period get history")
      await this.getHistory(info.from,info.to)
      let tr=o.calcTr(info.from,info.to)
      o.doZoom2(tr)
      return
//       if(this.props.graph.showSelect){// double check!
//       }else{
//         cl(vals)
//         cl(o)
//         cl(info)
//         let tr=o.calcTr(vals.fromTime, vals.toTime)
//         o.doZoom2(tr)
//       }
    },
    
    setNewSensors:(vals)=>{// returns true if we need to get data
      let newSensors=[]
      vals.forEach(v=>{ newSensors.push(`${v.s}-${v.z}-${v.c}-${v.i}`) })
      let oldSensors=[]
      this.sensors.forEach(v=>{ 
//         cl(v)
        oldSensors.push(`${v.s}-${v.z}-${v.c}-${v.i}`) 
        if(v.axis){v.axis.remove()}
      })
//       cl(oldSensors)
      o.deleteSensors(oldSensors, newSensors)
      return o.addSensors(oldSensors, newSensors,vals)// true if we need new data
//       if(vals.length<this.sensors.length){
//         o.deleteSensors(oldSensors, newSensors)
//         return false
// //         o.checkNewData(o.dispFrom,o.dispTo)
//       }else{
// //         cl("add sensors")
//         o.addSensors(oldSensors, newSensors,vals)
//         return true// need new data
// //         await this.getHistory(o.dispFrom,o.dispTo)
// //         o.checkNewData(o.dispFrom,o.dispTo)
//       }
    },
    
    setNewEvents:(vals)=>{// returns true if we need to get data
      // cl(vals)
      let newEvents=[]
      vals.forEach(v=>{ newEvents.push(v.id) })
      let oldEvents=[]
      // cl(this.events)
      this.events.forEach(v=>{ 
        // cl(v)
        oldEvents.push(v.id) 
        if(v.axis){v.axis.remove()}
      })
//       cl(oldSensors)
      o.deleteEvents(oldEvents, newEvents)
      return o.addEvents(oldEvents, newEvents,vals)// true if we need new data
//       if(vals.length<this.sensors.length){
//         o.deleteSensors(oldSensors, newSensors)
//         return false
// //         o.checkNewData(o.dispFrom,o.dispTo)
//       }else{
// //         cl("add sensors")
//         o.addSensors(oldSensors, newSensors,vals)
//         return true// need new data
// //         await this.getHistory(o.dispFrom,o.dispTo)
// //         o.checkNewData(o.dispFrom,o.dispTo)
//       }
    },

    onNewSensors:async(vals)=>{// if a sensor is added, need to get entire history
//       cl(`*********************************new sensors ${this.props.graph.divId}*************************************`)
      // cl(vals)
//       cl(this.props.graph.divId)
//       cl(`New Sensors: ${this.graphName}`)
      if(typeof(vals.zoomControls)!="undefined"){
        var transform = Object.create(d3.zoomTransform(o.svg2))
        transform.k = vals.zoomControls
        transform.x = -(o.config.width / 2 * vals.zoomControls) + o.config.width/2
        transform.y = -(o.config.height / 2 * vals.zoomControls) + o.config.height/2
        o.doZoom({transform: transform}, true)
        return
      }
      if(vals.sensors){// if axis
        if(true || this.props.graph.divId!="guide-graph"){
          vals.sensors.forEach((s, i) => {
            let si=s.options
            let so=this.sensors[i]
            if (si) {
              so.mode=si.mode
              so.min=si.min 
              so.max=si.max
              
              if(!so.options){so.options={}}
              so.options.min=si.min 
              so.options.max=si.max
              so.options.showGrid=si.showGrid||false
              so.color=si.color
            }
            // so.unit=si.unit
            //           cl(so.min)
            // THIS CODE IS REMOVING BAR
            // o.svg.selectAll("defs").remove()
            // o.defs=o.svg.append("defs")
            o.addGradients(so,vals.ind)
          })
//           cl(so.min)
        if(this.props.graph.divId!="guide-graph"){
          o.addYAxes()
//             cl(so.min)
        }
        o.checkNewData(o.dispFrom,o.dispTo)
//           cl(so.min)
        }
        return
      }
      if(typeof(vals.dataMarkers)!="undefined"){
//         cl("doing")
        info.showDM=vals.dataMarkers
        o.checkNewData(o.dispFrom,o.dispTo)
        return
      }
      if(typeof(vals.vBar)!="undefined"){
        // cl("show vbar")
        info.showVBar=vals.vBar
        o.checkNewData(o.dispFrom,o.dispTo)
        return
      }
      if(typeof(vals.combinedYAxis)!="undefined"){
        // cl("doing")
        info.showCombinedYAxis=vals.combinedYAxis
        o.checkNewData(o.dispFrom,o.dispTo)
        return
      }
      if(typeof(vals.mobileView)!="undefined"){
        // cl("show mobileview")
        info.showMobileView=vals.mobileView
        if (info.showMobileView) {
          if (this.props.graph.divId == "main-graph") {
            o.svg2.call(o.zoom)
            .on("wheel.zoom", null)// assign behavior
            .on('touchstart.zoom', null)
            .on('touchmove.zoom', null)
            .on('touchend.zoom', null)
          } else {
            o.svg2.call(o.zoom)
              .on("wheel.zoom", null)// assign behavior
          }
        } else {
          o.svg2.call(o.zoom)// assign behavior
        }
        o.checkNewData(o.dispFrom,o.dispTo)
        return
      }
      if(typeof(vals.zoomBar)!="undefined"){
        // cl("show zoombar")
        info.showZoomBar=vals.zoomBar
        // o.svg2.call(o.zoom).on("wheel.zoom", null)// assign behavior
        o.checkNewData(o.dispFrom,o.dispTo)
        return
      }
      if(o.setNewSensors(vals)) {
        // cl("on new sensors get history")
        await this.getHistory(o.dispFrom,o.dispTo)
      }
      o.checkNewData(o.dispFrom,o.dispTo)
//       let newSensors=[]
//       vals.forEach(v=>{ newSensors.push(`${v.s}-${v.z}-${v.c}-${v.i}`) })
//       let oldSensors=[]
//       this.sensors.forEach(v=>{ oldSensors.push(`${v.s}-${v.z}-${v.c}-${v.i}`) })
//       if(vals.length<this.sensors.length){
//         o.deleteSensors(oldSensors, newSensors)
//         o.checkNewData(o.dispFrom,o.dispTo)
//       }else{
//         o.addSensors(oldSensors, newSensors,vals)
//         await this.getHistory(o.dispFrom,o.dispTo)
//         o.checkNewData(o.dispFrom,o.dispTo)
//       }
      
//       cl(this.sensors)
//       cl(vals)
//       this.sensors=vals
//       let ad=o.allData
//       o.getRealData(ad.from,ad.to,vals)
//       cl(o.allData)
      
    },

    onNewEvents:async(vals)=>{// if an event is added/updated, need to get entire history
//       cl(`*********************************new sensors ${this.props.graph.divId}*************************************`)
//       cl(vals.dataMarkers)
//       cl(vals)
//       cl(this.props.graph.divId)
//       cl(`New Events: ${this.graphName}`)
      // cl(vals)
      // if(vals.length){// if events to show
        if(this.props.graph.divId!="main-graph"){
            // cl("adjusting events")
//           cl("axis")
          // let si=vals.events[vals.ind].options
          // let so=this.events[vals.ind]
//           cl(si)
//           cl(so)
          // so.mode=si.mode
          // so.min=si.min 
          // so.max=si.max
          // if(!so.options){so.options={}}
          // so.options.min=si.min 
          // so.options.max=si.max
          // so.options.showGrid=si.showGrid
          // so.color=si.color
          // so.unit=si.unit
//           cl(so.min)
          // o.addGradients(so,vals.ind)
//           cl(so.min)
            if(o.setNewEvents(vals)){
                // cl("on new events get history")
                await this.getHistory(o.dispFrom,o.dispTo)
              }
//             cl(so.min)
            o.checkNewData(o.dispFrom,o.dispTo)
//           cl(so.min)
          return
        // }
          // if(typeof(vals.dataMarkers)!="undefined"){
          //   cl("undefined")
          //   info.showDM=vals.dataMarkers
          //   o.checkNewData(o.dispFrom,o.dispTo)
          //   return
          // }
      }
//       if(typeof(vals.dataMarkers)!="undefined"){
// //         cl("doing")
//         info.showDM=vals.dataMarkers
//         o.checkNewData(o.dispFrom,o.dispTo)
//         return
//       }
      // if(o.setNewEvents(vals)){
      //   await this.getHistory(o.dispFrom,o.dispTo)
      // }
      // o.checkNewData(o.dispFrom,o.dispTo)      
    },
    
    onSelectZoom:(vals)=>{// from, to
      // cl("on select zoom")
      // cl(this.props.graph.divId)
      if(this.props.graph.showSelect){// double check!
        info.sFrom=vals.fromVal
        info.sTo=vals.toVal
//         cl(info.sFrom,info.sTo)
        o.setBox()
      }
    },
    
    // used for guide graph zoom (although maybe not anymore since zoom is handled by doZoom) and drag
    onSelectChange:(vals)=>{// from, to
      // cl("on select change")
      // cl(this.props.graph.divId)
      if(!this.props.graph.showSelect){// double check!
// this needs to calculate the transform values
        // cl(vals)
        let tr=o.calcTr(vals.fromVal, vals.toVal)
        o.doZoom2(tr)
//         cl(tr)
//         info.sFrom=vals.fromVal
//         info.sTo=vals.toVal
//         o.setBox()
      }
    },

    setBox:()=>{
//       cl("setbox")
      if(info.showSelect){
//         cl(info.sFrom,info.sTo)
//         cl(info.sFrom,info.sTo)
        o.left=o.x(1000*info.sFrom)
        o.right=o.x(1000*info.sTo)
//         cl(`setbox: ${o.left}`)
        o.moveBox()
      }
    },
    
    moveBox:()=>{
//       cl("movebox")
//       cl(o.left,o.right)
      let wid=o.right-o.left-5
      if(wid<0){wid=0}
      o.box
        .attr('x',o.left+5)
        .attr("width", wid)
      o.boxC
        .attr('x',o.left+5)
        .attr("width", wid)
              
      o.boxR
        .attr('x',o.right-5)
      o.boxL
        .attr('x',o.left)
    },
    
    addBox:(svg)=>{
      let h=o.config.height
      let y=o.config.height-h
//       let w=o.config.width-100
      o.boxP=svg.append("g")
//       cl(o.left,o.right)
//       cl(o.left,y)
      o.box=o.boxP
        .append("rect")
        .attr('id','center')
        .attr('x',o.left+5)
        .attr("width", o.right-o.left-5)
        .attr('y',y)
        .attr("height", h)
        .attr("fill",(o.config.dark)?"white":"black")
        .attr("opacity",0.2)
        .attr("stroke","red")
        .attr("cursor","pointer")
        .call(o.dragHandler)
      o.boxC=o.boxP
        .append("clipPath")
        .attr("id","boxClip")
        .append("rect")
        .attr('x',o.left+5)
        .attr("width", o.right-o.left-5)
        .attr('y',y)
        .attr("height", h)
        .attr("fill","black")
        .attr("opacity",0.1)
//         cl(o.right,y)
      o.boxR=o.boxP
        .append("rect")
        .attr('id','right')
        .attr('x',o.right-5)
        .attr('y',y)
        .attr("width", 5)
        .attr("height", h)
        .attr("fill","url(#handleGradient)")
//         .attr("stroke-width", "1px")
//         .attr("stroke", "#DDDDDD")
        .attr("cursor","ew-resize")
        .call(o.dragHandler)
      o.boxL=o.boxP
        .append("rect")
        .attr('id','left')
        .attr('x',o.left)
        .attr('y',y)
        .attr("width", 5)
        .attr("height", h)
        .attr("fill","url(#handleGradient)")
//         .attr("fill","#EEEEEE")
//         .attr("stroke-width", "1px")
//         .attr("stroke", "#DDDDDD")
        .attr("cursor","ew-resize")
        .call(o.dragHandler)
      
    },
    
    addXGridlines:()=>{
      o.xAxisGrid=d3.axisBottom(o.x)
          .ticks(20)
          .tickSize(0-o.config.height)
          .tickFormat("")
      o.svgxg=o.svg2.append("g")
        .attr("class", "x grid")
        .attr("transform", "translate(0," + o.config.height + ")")
        .attr("opacity", 0.05)
        .call(o.xAxisGrid)
    },
    
    addXAxis:(svg,minTime,maxTime)=>{
      let tv=o.makeXTickVals(minTime,maxTime)
//       cl(tv)
      let range=(maxTime-minTime)/3600
      
      let ticks=o.makeXTickVals(minTime,maxTime)
//       let step=30
//       if(ticks>150){step=}
//       cl(range)
//       cl(o)
      // cl(o.x)
      if (this.props.graph.divId == "event-timeline") ticks = ticks.map((d)=>{return 0})
      if(range>24){
        o.xAxis=d3.axisBottom(o.x)
//             .ticks(5)
            .tickValues(ticks)
            .tickFormat(d3.timeFormat("%b:%e:%y %H:%M"))
      }else{
        o.xAxis=d3.axisBottom(o.x)
            .tickValues(ticks)
            .tickFormat(d3.timeFormat("%H:%M"))
      }
        o.svgx=svg.append("g")
        .attr("class", "x axis")
        .attr("transform", "translate(0," + o.config.height + ")")
        .attr("opacity",o.config.opacity)
        .call(o.xAxis)
      if(info.showGrid){o.addXGridlines()}
//       cl(info.showDM)
    },
    
    getFromTo:(tr)=>{// only called on main graph, zooming
//       cl(tr)
      if(!o.zr){
        let gr=this.props.graph
        let [fromVal,toVal]=o.calcFromTo(tr)// the limits of the new transform
        if(fromVal<gr.gFrom){fromVal=gr.gFrom}// compare with limits of data
        if(toVal>gr.gTo){toVal=gr.gTo}
        Object.assign(tr,o.calcTr(fromVal,toVal))
//         cl("select zoom and select change")
        // eventually calls onSelectZoom func
        o.onChange("selectZoom",{fromVal:fromVal,toVal:toVal})
        o.onChange("selectChange",{fromVal:fromVal,toVal:toVal})
      }
    },
    
    doZoom2:(tr)=>{
//       cl("doZoom2")
        // cl(this.props.graph)
      if(!this.props.graph.showTimePeriod){ // not showing popup
        // cl("doZoom2 adjust scale")
          o.pathsParent.attr("transform",`translate(${tr.x},0) scale(${tr.k},1) `)// adjust sensor paths
          o.shadeParent.attr("transform",`translate(${tr.x},0) scale(${tr.k},1) `)// adjust sensor paths
          o.dotsParent.attr("transform",`translate(${tr.x},0) scale(${tr.k},1) `)// adjust sensor paths
  //         this.sensors.forEach(s=>{
  //           s.path.attr("transform",`translate(${tr.x},0) scale(${tr.k},1) `)// adjust sensor paths
  //         })
          if(info.showSelect){o.boxP.attr("transform",`translate(${tr.x},0) scale(${tr.k},1) `)} // do select box
  //         o.setBox()// 
          o.throttleNewData(tr)// load new data
      }
    },
    
    doZoom:(e, mobile=false)=>{// this really shouldn't be called when a graph is being initialized
//       let maxZoom=3600
      let tr=e.transform
      // cl(tr)
      // if zooming in and current selection can still be zoomed (selection is less than zoom) and not guide graph (because diff zoom)
      if((tr.k>1)&&((o.dispTo-o.dispFrom<o.maxZoom)||(info.sTo-info.sFrom<o.maxZoom))&&!this.props.graph.showSelect){
        o.resetZoom()
        return
      }
      // showTimePeriod means that the dialog is showing, and *don't* zoom or anything
      if(!this.props.graph.showTimePeriod){
        // cl(`do guide graph zoom ${this.props.graph.divId}`)
//         cl(tr)
        if(info.showSelect&&!this.updating&&!mobile){// guide graph
//           cl([o.dispFrom,o.dispTo])
          let [fromVal,toVal]=o.calcFromTo(tr)
          // if new calculated range is more zoomed in than existing range
          if((info.sFrom>=fromVal)&&(info.sTo<toVal)){
            // update ranges
            o.dispFrom=fromVal
            o.dispTo=toVal
            info.from=fromVal
            info.to=toVal
            if(info.sFrom<info.from){info.sFrom=info.from}
            if(info.sTo>info.to){info.sTo=info.to}
  //           cl([info.sFrom,info.sTo])
            if((info.sTo-info.sFrom)<=o.maxZoom){
              // cl("resetting for max zoom")
              if(info.sTo==info.to){info.sFrom=info.sTo-o.maxZoom}
              if(info.sFrom==info.from){info.sTo=info.sFrom+o.maxZoom}
            }
            // do guide zoom
            o.onChange("guideZoom",{fromVal:fromVal,toVal:toVal})
          }
        }else {// other graphs
          // do zoom of graph
          if (!mobile || mobile && this.props.graph.divId == "main-graph") {
            o.getFromTo(tr)
          }
        }// calculate from and to, and send to select graph
        if (!mobile || mobile && this.props.graph.divId == "main-graph") {
          o.doZoom2(tr)
          if(o.svgx){o.svgx.call(o.xAxis.scale(tr.rescaleX(o.x)))}// rescale x axis
          if(o.svgxg){o.svgxg.call(o.xAxisGrid.scale(tr.rescaleX(o.x)))}// rescale x axis
        }
      }
    },

    // doMove: (e) => {
    //     var vertical = d3.selectAll("rect")
    //       .append("div")
    //       .attr("class", "remove")
    //       .style("position", "absolute")
    //       .style("z-index", "19")
    //       .style("width", "1px")
    //       .style("height", "380px")
    //       .style("top", "10px")
    //       .style("bottom", "30px")
    //       .style("left", "0px")
    //       .style("background", "#fff"); 
    //     let mouse_pos = d3.pointer(e, this)
    //     cl(mouse_pos)
    //     let mousex = mouse_pos[0] + 5
    //     // show vertical bar
    //     vertical.style("left", mousex + "px" )
    //     // highlight line/data point nearest to mouse
    // },

    moveHandler: () => {
        let pos
        // append g for all mouse over effects TODO - limit to graph area, no axes
        o.mouseG = o.svg2.append("g")
          .attr("class", "mouse-over-effects");

        // append vertical line
        var mouseLine = o.mouseG.append("path")
          .attr("class", "mouse-line")
          .style("stroke", (o.config.dark)?"white":"black")
          .style("stroke-width", "1px")
          .style("opacity", (info.showMobileView) ? "1" :  "0");

          // <div style="pointer-events: none; position: absolute; 
          // z-index: 10; top: 0px; left: 0px; transform: translate(504.133px, 82.3438px);">
        o.mouseBox = d3.select("#main-graph").append("div")
            .style("pointer-events", "none")
            .style("position", "relative")
            .style("z-index", "10")
            .style("opacity", (info.showMobileView) ? "1" :  "0")
            .style("top", `-${o.config.height + 23}px`)
            .style("display", "inline-block")

        // attach other elements
        var innerMouseBox = o.mouseBox.append("div")
          .style("background", "rgba(255, 255, 255, .1)")
          .style("color", "inherit")
          .style("font-size", "inherit")
          .style("border-radius", "2px")
          .style("box-shadow", "rgba(0, 0, 0, 0.4) 0px 1px 2px")
          .style("padding", "5px 9px")
              .append("div")
              .style("white-space", "pre")
              .style("display", "block")
              .style("align-items", "center")

        // reference all
        // var lines = this.sensors.map((s) => {
        //     return s.path
        // })
        var lines = document.getElementsByClassName("line")
        let sensors = this.sensors
        let humStages = this.humStages
        let overrides=this.overrides
        let tempStages = this.tempStages
        // append g for each circle and text on line
        var mousePerLine = o.mouseG.selectAll('.mouse-per-line')
          .data(sensors)
          .enter()
          .append("g")
          .attr("class", "mouse-per-line");

        // circle
        var circle = mousePerLine.append("circle")
          .attr("r", 7)
          .style("stroke", function(d) {
            return d.color;
          })
          .style("fill", "none")
          .style("stroke-width", "1px")
          .style("opacity", "0");

        var fontSize = 15
        var maxOffset = 0
        // text - value of sensor
        var text = mousePerLine.append("text")
          .attr("transform", "translate(10,-5)");
        // rect to capture mouse movements
        var yRange = o.y.range()
        var closestLine = null
        // calculate dict
        o.pathDict = {}

        let doMouseMove = (e, curr) => {
          // TODO get real center of graph
          var mouse = (info.showMobileView) ? [o.config.width/2, o.config.height/2] : d3.pointer(e, curr);
          var mouseBoxText = []
          var mouseBoxTime = null
          var mousee = e
          var closestLineOffset = Number.MAX_VALUE
          var closestLineIdx = -1
          // move the vertical line
          mouseLine
            .attr("d", function() {
              var d = "M" + mouse[0] + "," + o.config.height;
              d += " " + mouse[0] + "," + 0;
              return d;
            });
          // position the circle and text
          var xDate = o.x.invert(mouse[0])
          var bisect = d3.bisector(function(d) { return d.t; }).right;
          mousePerLine
            .attr("transform", function(d, i) {
              if (lines[i]) {
                  var idx = bisect(d.data, xDate);

                  // get the intersection of our vertical line and the data line
                  if (d.data[idx] && d.data[idx-1]) {
                      var pos = o.getLineIntersection(
                        mouse[0],  
                        yRange[0], 
                        mouse[0], 
                        yRange[1],
                        o.x(d.data[idx-1].t),
                        sensors[i].y(d.data[idx-1].v),
                        o.x(d.data[idx].t),
                        sensors[i].y(d.data[idx].v)
                      );
                      if (pos.x && pos.y) {
                          // use pos to determine point at length
                          let calc_y = pos.y
                          if (o.getCurveType(sensors[i]) == d3.curveStepAfter) {
                                  calc_y = sensors[i].y(d.data[idx-1].v)
                          }
                          // only do expensive calculation if account feature enabled
                          if (acctFeature("advancedGraphingInterp")) {
                              let acalc_y = o.findYatXbyBisection(mouse[0], lines[i])
                              if (acalc_y == o.config.height) calc_y = pos.y
                          }
                          mouseBoxTime = xDate
                          var val
                          if(["stT"].includes(sensors[i].id.substring(2))){
                              val = tempStages[Math.round(d.data[idx-1].v)]
                          }
                          else if(["stH"].includes(sensors[i].id.substring(2))){
                              val = humStages[Math.round(d.data[idx-1].v)]
                          }
                          else if(["zoS"].includes(sensors[i].id.substring(2))){
                              val = sensors[i].setpoints[Math.round(d.data[idx-1].v)].name
                          }
                          else if(sensors[i].id.substring(2,4)=="co"){
                            val = overrides[Math.round(d.data[idx-1].v)]
                          }

                          // else if(["c03dli", "c00dli"].includes(sensors[i].id.substring(2))){
                          //   val = ((d.y.invert(calc_y).toFixed(2)) / 1000000).toFixed(4)
                          // }
                          else {
                              val = (sensors[i].max == 1 && sensors[i].min == 0) ? ((d.data[idx-1].v) ? "ON" : "OFF")
                                : d.y.invert(calc_y).toFixed(2)
                          }
                          var text = `${val}${d.unit} ${d.name}`
                          var offset = (pos.x > 500) ? 0.49*text.length*fontSize : 0
                          mouseBoxText.push({
                              text: text,
                              color: d.color || d.options?.color,
                              line: i 
                          })
                          maxOffset = Math.max(maxOffset, offset)
                          // cl([Math.abs(mouse[1] - calc_y), closestLineOffset])
                          closestLineOffset = Math.min(Math.abs(mouse[1] - calc_y), closestLineOffset)
                          if (closestLineOffset == Math.abs(mouse[1] - calc_y)) {
                              // cl(`closest line is ${i}`)
                              closestLineIdx = i
                          } 
                          d3.select(curr).style('opacity', 1)
                          return "translate(" + mouse[0] + "," + calc_y +")";
                      }
                  }
                  // hide circle if no data could be determined
                  d3.select(curr).style('opacity', 0)
                  if (info.showCombinedYAxis || info.mobileView) {
                      mouseBoxText.push({
                          text: `--${d.unit} ${d.name}`,
                          color: d.color || d.options?.color,
                          line: i 
                      })
                  }

              }
        });
          if (mouseBoxTime || ((info.showCombinedYAxis||info.showMobileView) && mouseBoxText.length)) {
              o.mouseBox
                  .style("right", ()=>{
                      if (info.showCombinedYAxis || info.showMobileView) {
                          return `${-o.config.width + Math.max(271.9270935058594, o.mouseBox.node().getBoundingClientRect().width)}px`
                      } else {
                          maxOffset = Math.round(maxOffset / 100) * 100
                          return `-${(mousee.clientX > o.config.width/2) ?  mousee.clientX -(maxOffset + 120) : mousee.clientX - 40}px`
                      }
              })
              innerMouseBox.selectAll("div").remove()
              // add date
              if (mouseBoxTime) {
                  var dateDiv = innerMouseBox.append("div")
                    .style("display", "flex")
                    .style("align-items", "center")
                  dateDiv.append("div")
                  .text(dateToDisplayDate(new Date(mouseBoxTime),"mm/dd/yyyy h:mm:ss ap"))
              }
              mouseBoxText.forEach((v, i) => {
                  var div = innerMouseBox.append("div")
                    .style("display", "flex")
                    .style("align-items", "center")
                  div.append("tspan")
                    .style("height", "12px")
                    .style("width", "12px")
                    .style("background", v.color) // color of line
                    .style("margin-right", "7px")
                  div.append("div")
                  .text(`${v.text}`)
                      .style("font-weight", (closestLineIdx == v.line) ? "bold" : "")
              })
              const mouseBoxTextSize = mouseBoxText.length
              circle
                .style("opacity", (mouseBoxTime) ? "1" : "0");
              text
                .style("opacity", "1");
              o.mouseBox
                .style("opacity", mouseBoxTextSize > 5 ? ".98" : ".92");

              // highlight closest line, unhighlight prev closest line
              if (closestLine) {
                d3.select(closestLine)
                    .attr("stroke-width", 3)
              }
              if (closestLineIdx != -1) {
                  closestLine = lines[closestLineIdx]
                  d3.select(closestLine)
                    .attr("stroke-width", 5)
                  // bold text
              }
          } else {
              // unhighlight line
              if (closestLine) {
                d3.select(closestLine)
                    .attr("stroke-width", 3)
              }
              circle
                .style("opacity", "0");
              text
                .style("opacity", "0");
              o.mouseBox
                .style("opacity", "0");
          }

          // add grj based on closest line or original sensor
          // cl(sensors)
          // cl(mouseBoxText)
          o.mouseG
          .attr("id", ()=> {
              let idx = (closestLineIdx != -1) ? closestLineIdx : 0
              let s = sensors[idx]
              if (s) {
                  return `{"cmd":"graph", "type": "sensor", "s": "${s.s}", "zInd": ${s.z}, "id": "${s.id}", "c": ${s.c},"t": ${Math.floor(xDate)}, "v": "${mouseBoxText[idx]?.text}"}`
              }
          })
        }
        let mouseRect = o.mouseG.append('svg:rect')
          .attr('width', o.config.width)
          .attr('height', o.config.height)
          .attr('fill', 'none')
          .attr('pointer-events', (info.showMobileView) ? 'none': 'all')
          .on('mouseout', function() { // on mouse out hide line, circles and text
            if (!info.showMobileView) {
              mouseLine
                .style("opacity", "0");
              circle
                .style("opacity", "0");
              text
                .style("opacity", "0");
              o.mouseBox
                .style("opacity", "0");
              if (closestLine) {
                d3.select(closestLine)
                    .attr("stroke-width", 3)
              }
            }
          })
          .on('mouseover', function() { // on mouse in show line, circles and text
            mouseLine
              .style("opacity", "1");
          })
          .on('mousemove', function(e) { // mouse moving over canvas
            doMouseMove(e, this)
          });
        if (info.showMobileView) {
          mouseRect.on("mousemove")({})          
        } 
    },

    getLineIntersection:(p0_x, p0_y, p1_x, p1_y, p2_x, p2_y, p3_x, p3_y) => {
        var rV = {};
        var s1_x, s1_y, s2_x, s2_y;
        s1_x = p1_x - p0_x;     s1_y = p1_y - p0_y;
        s2_x = p3_x - p2_x;     s2_y = p3_y - p2_y;

        var s, t;
        s = (-s1_y * (p0_x - p2_x) + s1_x * (p0_y - p2_y)) / (-s2_x * s1_y + s1_x * s2_y);
        t = ( s2_x * (p0_y - p2_y) - s2_y * (p0_x - p2_x)) / (-s2_x * s1_y + s1_x * s2_y);

        if (s >= 0 && s <= 1 && t >= 0 && t <= 1) {
            // Collision detected
            rV.x = p0_x + (t * s1_x);
            rV.y = p0_y + (t * s1_y);
        }
        return rV;
    },

   findYatXbyBisection : (x, path, error=.01) => {
       var length_end, point
        , length_start = 0
        , bisection_iterations_max = 15
        , bisection_iterations = 0
       if (!o.pathDict[path]) {
//            cl("assigning to dict")
          o.pathDict[path] = {}
          o.pathDict[path].length_end = path.getTotalLength()
          o.pathDict[path].point = path.getPointAtLength(path.getTotalLength() / 2)

       } 
      length_end = o.pathDict[path].length_end
      point = o.pathDict[path].point

      while (x < point.x - error || x > point.x + error) {
        // get the middle point
        point = path.getPointAtLength((length_end + length_start) / 2)

        if (x < point.x) {
          length_end = (length_start + length_end)/2
        } else {
          length_start = (length_start + length_end)/2
        }

        // Increase iteration
        if(bisection_iterations_max < ++ bisection_iterations)
          break;
      }
      return point.y
    },


    makeSvg2:(svgDiv)=>{
//       cl(o)
      var svg = d3.select(svgDiv).append("svg")
      .attr("viewBox",[0,0,
            o.config.width + o.config.margin.left + o.config.margin.right,
            o.config.height + o.config.margin.top + o.config.margin.bottom])
      o.defs=svg.append("defs")
      o.svg2=svg// main svg
        .append("g")
        .attr("transform", "translate(" + o.config.margin.left + "," + o.config.margin.top + ")")
//         cl(o.config.width,o.config.height)
//       cl(o.config.dark)
      o.svg2// graphing area
        .append("rect")
        .attr("width", o.config.width)
        .attr("height", o.config.height)
        .attr("fill",(o.config.dark)?"black":"white")
     if (this.props.graph.divId != "event-timeline") {
      o.cpRect=svg.append("clipPath")// clipping
        .attr("id","myclip")
      o.cpRect// rect to to clip to
        .append("rect")
        .attr("width",o.config.width)
        .attr("height",o.config.height)
        .attr("fill","white")
     }
//       cl("make svg2")
      o.zoom=d3.zoom().on('zoom', o.doZoom)// zoom function
      // o.svg2.call(o.zoom).on("wheel.zoom", null)// assign behavior
      if (info.showMobileView) {
        if (this.props.graph.divId == "main-graph") {
          o.svg2.call(o.zoom)
          .on("wheel.zoom", null)// assign behavior
          .on('touchstart.zoom', null)
          .on('touchmove.zoom', null)
          .on('touchend.zoom', null)
        } else {
          o.svg2.call(o.zoom)
            .on("wheel.zoom", null)// assign behavior
        }
      } else {
        o.svg2.call(o.zoom)// assign behavior
      }
      o.clipG= o.svg2.append("g")// clipping group
      if (this.props.graph.divId != "event-timeline") o.clipG.attr("clip-path","url(#myclip)")
      o.graphParent=o.clipG.append("g")
      o.shadeParent=o.graphParent.append("g")
      o.pathsParent=o.graphParent.append("g")
      o.dotsParent=o.graphParent.append("g")
      o.threshParent=o.graphParent.append("g")
      if(info.showSelect){
        o.shadeParent
          .attr("clip-path","url(#boxClip)")
        o.makeHandleGradient()
      }
        return svg
    },

    makeSvg:(svgDiv)=>{
//       cl(svgDiv)
      o.setConfig()
      o.svg=o.makeSvg2(svgDiv)
//       o.addXAxis(o.svg2)
//       o.addXGridlines()
//       o.addYAxes(o.svg2)
//       o.addPaths()
      this.props.graph.sensors.forEach((s,i)=>{o.addGradients(s,i)})
//       o.addShades()
      
      if(info.showSelect){o.addBox(o.svg2)}
      // if (this.props.graph.divId == "main-graph") {
      //     cl("this is being called")
      //     if (o.mouseG){o.mouseG.remove()} 
      //     if (info.showVBar) o.moveHandler()
      // }
//       cl(info)
      o.setBox()
//       o.dragHandler(o.svg2)
      
    },
  }
  
  o.makeSvg(info.svg)
//   cl("make svg")
  return o
  
}// the end of graph01


  render() {

//     cl(`Graph ${this.props.graph.divId}: ${this.props.graph.from} to ${this.props.graph.to}`)
//     cl(`Render ${this.props.graph.divId}`)
//     cl(this.props)
//     cl([this.props.graph.from,this.graph?.dispFrom])
    
    
//     let gr=this.graph
// //     cl(this.graph)
//     if(this.graph){
//       if(gr.dispFrom && gr.dispTo){
//         let pg=this.props.graph
// //         cl(pg.sensors)
// //         cl(Object.keys(gr.allData.sensors))
// //         cl(Object.keys(gr.allData.sensors).length,pg.sensors.length)
//         if((pg.from!=gr.dispFrom)||(pg.to!=gr.dispTo)/*||(Object.keys(gr.allData.sensors).length!=pg.sensors.length)*/){
//           cl("redraw")
//           this.graph.getRealData(pg.from,pg.to)
//         }
//       }
//     }
    
    
//     cl("render")
//     cl(this.props.graph.ref.current)
//  ref={this.svgDiv}
     //style={{width: 400, height: 400}}
//           style={{
//             
//             width:"100%",
//              height: 200,
//              marginTop:32,
//              marginBottom:1,
// //              backgroundColor:"#DDDDDD",
//           }}
//         style={{backgroundColor: "white"}}
//     cl("render")
//     cl(this.props)
    if(this.props.graph.divId=="guide-graph"){
      return(
        <div 
          id={this.props.graph.divId} 
          style={{height:100}}
          ref={this.svgDiv}
        />
      )
    }else if (this.props.graph.divId=="event-timeline"){
       return(
        <div 
          id={this.props.graph.divId} 
          style={{height:50}}
          ref={this.svgDiv}
        />
      ) 
    }
    else {
      return(
        <div id={this.props.graph.divId} ref={this.svgDiv}
          style={{height:400}}>
            {this.props.graph.loading && this.props.graph.loading()}
        </div>
      )
    }
  }
}

export default Graph01;
